<template>
    <div id="form">
        <div v-if="tradingAccountList.totalLiveAccounts > 0">
            <div class="mainTitle text-center mb-3">
                <h2 class="mb-3">{{ $t("dep_acc_fund_depFundAcc") }} <span v-if="account_id != ''">{{ account_id }}</span></h2>
                <complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
                <message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != '' && trans_id == ''"></message-component>
            </div>
            <div class="fxdepositfund d-flex align-items-center justify-content-center accountList flex-wrap" v-if="shwStep == 1">
                <div
                    v-for="(list, key) in tradingAccountList.records"
                    :class="account_id == list.account_id ? 'accountBox selected' : 'accountBox'
                    "v-if="parseInt(list.demo_live) == 1"
                    v-on:click.stop.prevent="act_account_id = list.act_account_id; account_id = list.account_id; currency_selected = list.currency; shwOption = false; ">
                    <div class="head d-flex align-items-center justify-content-between">
                        <div class="d-flex">
                            <div class="platformLogo pr-3">
                                <img
                                    :src="'../../../../static/fxView/images/' +
                                    $env_var.platformIcon[list.platform]
                                    "
                                    alt="mt4"
                                />
                            </div>
                            <div class="detail">
                                <div class="tradingId"><span>{{ $t("dep_acc_fund_tradAccId") }}</span>{{ list.account_id }}</div>
                            </div>
                        </div>
                        <div class="acntType" v-if="list.demo_live == 1">
                            {{ $t("dash_live") }}
                        </div>
                    </div>
                    <div class="ftr d-flex align-items-center justify-content-between">
                        <div class="accountCurncy">
                            <img
                                :src="'../../../../static/fxView/images/' +
                                list.currency.toLowerCase() +
                                '.svg'
                                "
                                alt="usd"
                                class="rounded-circle"
                            />
                            {{ list.currency }}
                        </div>
                        <div class="acntType" v-if="list.demo_live == 0">
                            {{ $t("dash_demo") }}
                        </div>
                        <div
                            class="depositNow"
                            @click.prevent="
                            account_id = list.account_id;
                            currency_selected = list.currency;
                            amount_msz_error = '';
                            transactionLimitCurrency();
                            "
                            >
                            <a>{{ $t("dep_acc_fund_depFund") }}</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="CustomBlockWidth accountList" v-if="shwStep == 2">
                <div class="row justify-content-center">
                    <div class="stepForm middleBox">
                        <div class="whiteBG p-3">
                            <h4 class="mb-3">{{ $t("dep_acc_fund_selDepMet") }}</h4>
                            <div class="form-group d-flex justify-content-start align-items-center field-wrapper mb-3">
                                <ul class="twoColumn flex-wrap justify-content-start depositpaymentMethod w-100">
                                    <template
                                        class="mb-3 mr-2"
                                        v-for="(list, key) in $env_var.withdrawalMethod"
                                        v-if="(parseInt(key) == 1 && checkPaymentOptionEligibility(1)) ||
                                        (parseInt(key) == 18 && checkPaymentOptionEligibility(18)) || parseInt(key) == 23 ||
                                        (parseInt(key) == 24 && checkPaymentOptionEligibility(24)) ||
                                        (parseInt(key) == 25 && checkPaymentOptionEligibility(25)) ||
                                        (parseInt(key) == 26 && checkPaymentOptionEligibility(26)) ||
                                        // (parseInt(key) == 27 && checkPaymentOptionEligibility(27)) ||
                                        // (parseInt(key) == 31 && checkPaymentOptionEligibility(31)) ||
                                        (parseInt(key) == 32 && checkPaymentOptionEligibility(32)) ||
                                        (parseInt(key) == 33 && checkPaymentOptionEligibility(33)) ||
                                        (parseInt(key) == 2 && checkPaymentOptionEligibility(2)) ||
                                        (parseInt(key) == 37 && checkPaymentOptionEligibility(37) ) ||
                                        (parseInt(key) == 38 && checkPaymentOptionEligibility(38)) ||
                                        (parseInt(key) == 39 && checkPaymentOptionEligibility(39)) ||
                                        (parseInt(key) == 40 && checkPaymentOptionEligibility(40)) ||   
                                        (parseInt(key) == 41 && checkPaymentOptionEligibility(41)) || 
                                        // (parseInt(key) == 5 && checkPaymentOptionEligibility(5)) ||
                                        (parseInt(key) == 3 && checkPaymentOptionEligibility(3))"
                                    >
                                        <li class="mb-3 mr-2 align" :class="[
                                            (parseInt(get_method_id) == parseInt(key) ? 'selected' : '') , 
                                            {'disabled' : ([32,37].includes(parseInt(key)) && get_user.verified_status < 2) }
                                        ]" v-if="parseInt(key) != 27 " >
                                            <label class="customRadio-button d-flex justify-content-between align-items-center">
                                                <div class="lft d-flex align-items-center justify-content-start">
                                                    <img
                                                        :src="'../../../../static/fxView/images/' +
                                                        checkPaymentOptionEligibility(key, true)
                                                        "
                                                        alt="Bank Account"
                                                        class="mr-2"
                                                    />
                                                </div>
                                                <div class="rft">
                                                    <input
                                                        type="radio"
                                                        name="radio"
                                                        v-validate="{ required: true }"
                                                        :value="depositValue[parseInt(key)]"
                                                        v-model="pay_option"
                                                        v-on:change="select_option_method(key)"
                                                        :class="{
                                                            'is-invalid': submitted && errors.has('radio'),
                                                        }"
                                                        ref="radioInput"
                                                    />
                                                    <span class="checkmark"></span>
                                                </div>
                                            </label>
                                        </li>
                                        <template v-else-if="astroPayCountryMethods[get_user.profile.residence_country]">
                                            <li
                                                class="mb-3 mr-2 flex-column"
                                                v-for="pay_code in astroPayCountryMethods[get_user.profile.residence_country]"
                                                v-if="pay_code.isAllow"
                                                :class="(pay_option === pay_code.code ? 'selected' : '') || (parseInt(key) == 18 && parseInt(get_user.verified_status) == 0 ? 'disabled' : '')"
                                            >
                                                <label class="customRadio-button d-flex justify-content-between align-items-center">
                                                    <div class="lft d-flex align-items-center justify-content-start">
                                                        <img style="height: 70px; object-fit: cover; object-position: top center;" :src="$env_var.astroPayImage.replace('{{PM}}', pay_code.code)" alt="Bank Account" class="mr-2" />
                                                    </div>
                                                    <div class="rft">
                                                        <input
                                                            type="radio"
                                                            name="radio"
                                                            v-validate="{ required: true }"
                                                            :value="pay_code.code"
                                                            v-model="pay_option"
                                                            v-on:change="select_option_method(key)"
                                                            :class="{ 'is-invalid': submitted && errors.has('radio') }"
                                                            ref="radioInput"
                                                        />
                                                        <span class="checkmark"></span>
                                                    </div>
                                                </label>
                                                <span class="method-name f-12 pt-1">{{ pay_code.pay_method }}</span>
                                            </li>
                                        </template>
                                    </template>
                                </ul>
                            </div>
                            <p class="error mb-3" v-if="error in errors.collect('radio')">
                                {{ $t("dep_acc_fund_depFieldReq") }}
                            </p>
                            <div class="clearfix"></div>
                            <div v-if="parseInt(get_method_id) == 1">
                                <div class="personalForm list-group mb-3 d-flex justify-content-between align-items-center">
                                    <div class="list-group-item w-100 d-flex align-items-center justify-content-center">
                                        <span>{{ $t("depMsz1") }}<strong> {{$t('fxWorkingDays')}}</strong></span>
                                        <span class="justify-content-end">{{ $t("depMsz3") }}<strong>{{ $t("depMsz4") }}</strong></span>
                                    </div>
                                </div>
                                <p class="mb-2">{{$t('fxBankdetails')}}</p>
                                <div v-for="(list, index) in $env_var.depositBankListDetail" class="mb-3">
                                    <div class="list-group-item head">
                                        <div class="d-flex justify-content-between align-items-center">
                                            <div>
                                                <p><span>{{ list.region }}</span></p>
                                            </div>
                                            <div>
                                                <a href="#" class="green" @click="detailDiv(index);" v-if="index == showIndex">{{$t('fxLessDetail')}}</a>
                                                <a href="#" class="green" @click="detailDiv(index);" v-else>{{$t('fxViewDetail')}}</a>
                                            </div>
                                        </div>
                                        <div class="border p-2 mt-2 whiteBG w-100 radius">
                                            <p class="mb-0">
                                                <span>{{$t('fxMinimumDepositAmount')}} <b>{{ list.min_deposit }} </b> </span>
                                            </p>
                                        </div>
                                    </div>
                                    <div class="personalForm list-group mb-3" :ref="'buttons' + index" v-if="index == showIndex">
                                        <div>
                                            <div class="list-group-item d-flex align-items-center justify-content-center"><span>{{$t('fxHolderName')}}</span> <span>{{ list.account_holder_name }}</span></div>
                                            <div class="list-group-item d-flex align-items-center justify-content-center"><span>{{$t('fxAccountNumber')}}</span> <span>{{ list.account_number }}</span></div>
                                            <div class="list-group-item d-flex align-items-center justify-content-center"><span>{{$t('fxBankName')}}</span> <span>{{ list.Bank_Name }}</span></div>
                                            <div class="list-group-item d-flex align-items-center justify-content-center"><span>{{$t('fxSwiftBIC')}}</span> <span>{{ list.SWIFT }}</span></div>
                                            <div class="list-group-item d-flex align-items-center justify-content-center">
                                                <span>{{$t('fxIBAN')}}</span> 
                                                <span style="color: red" v-if="currency_selected.toUpperCase() == 'GBP'">{{ list.GBP_IBAN }}</span>
                                                <span  v-else>{{ list.IBAN }}</span>
                                            </div>
                                            <div class="list-group-item d-flex align-items-center justify-content-center"><span>{{$t('fxAddress')}}</span> <span>{{ list.address }}</span></div>
                                            <div class="list-group-item d-flex align-items-center justify-content-center">
                                                <span><b>{{$t('fxReference')}}</b></span> <span><b>{{$t('fxForTradAccount')}} {{ account_id }}</b></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="parseInt(get_method_id) == 1 && isSACountry()">
                                <div v-for="(list, index) in $env_var.depositBankListDetailFNB" class="mb-3">
                                    <div class="list-group-item head">
                                        <div class="d-flex justify-content-between align-items-center">
                                            <div>
                                                <p><span>{{ list.region }}</span></p>
                                            </div>
                                            <div>
                                                <a href="#" class="green" @click="detailDiv1(index);" v-if="index == showIndex1">{{$t('fxLessDetail')}}</a>
                                                <a href="#" class="green" @click="detailDiv1(index);" v-else>{{$t('fxViewDetail')}}</a>
                                            </div>
                                        </div>
                                        <div class="border p-2 mt-2 whiteBG w-100 radius">
                                            <p class="mb-0">
                                                <span>{{$t('fxMinimumDepositAmount')}} <b>{{ list.min_deposit }} </b> </span>
                                            </p>
                                        </div>
                                    </div>
                                    <div class="personalForm list-group mb-3" :ref="'buttons' + index" v-if="index == showIndex1">
                                        <div>
                                            <div class="list-group-item d-flex align-items-center justify-content-center"><span>{{$t('fxAccountNumber')}}</span> <span>{{ list.account_number }}</span></div>
                                            <div class="list-group-item d-flex align-items-center justify-content-center"><span>{{$t('fxHolderName')}}</span> <span>{{ list.account_holder_name }}</span></div>
                                            <div class="list-group-item d-flex align-items-center justify-content-center"><span>{{$t('fxBankName')}}</span> <span>{{ list.Bank_Name }}</span></div>
                                            <div class="list-group-item d-flex align-items-center justify-content-center"><span>{{$t('fxSwiftBIC')}}</span> <span>{{ list.SWIFT }}</span></div>
                                            <div class="list-group-item d-flex align-items-center justify-content-center"><span>{{$t('fxAddress')}}</span> <span>{{ list.address }}</span></div>
                                            <div class="list-group-item d-flex align-items-center justify-content-center">
                                                <span><b>{{$t('fxReference')}}</b></span> <span><b>{{$t('fxForTradAccount')}} {{ account_id }}</b></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="parseInt(get_method_id) == 5">
                                <div class="personalForm list-group mb-3 d-flex justify-content-between align-items-center">
                                    <div class="list-group-item w-100">
                                        <span>
                                            {{ $t("dep_acc_fund_MinDepAmt") }}:
                                            <b class="ml-2">
                                                {{ $env_var.currencyIcon[currency_selected.toUpperCase()] }} {{ (currency_selected.toUpperCase() != 'ZAR') ? checkSuccessDeposit() ? 50 : 50 : checkSuccessDeposit() ? 80 : 800 }}
                                            </b>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div v-if="parseInt(get_method_id) == 32">
                                <div class="personalForm list-group mb-3 d-flex justify-content-between align-items-center">
                                    <div class="list-group-item w-100">
                                        <span>
                                            {{ $t("dep_acc_fund_MinDepAmt") }}:
                                            <b class="ml-2">
                                                {{ $env_var.currencyIcon[currency_selected.toUpperCase()] }} {{ (currency_selected.toUpperCase() != 'ZAR') ? checkSuccessDeposit() ? 50 : 50 : checkSuccessDeposit() ? 80 : 800 }}
                                            </b>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div v-if="parseInt(get_method_id) == 3">
                                <div>
                                    <div class="personalForm list-group mb-3 d-flex justify-content-between align-items-center">
                                        <div class="list-group-item w-100">
                                            <span>{{ $t("depMsz1") }}<strong>{{ $t("depMsz10") }}</strong></span>
                                            <span>{{ $t("depMsz3") }}<strong>{{ $t("depMsz4") }}</strong></span>
                                        </div>
                                    </div>
                                    <div class="personalForm list-group mb-3 d-flex justify-content-between align-items-center">
                                        <div class="list-group-item w-100">
                                            <span>
                                                {{ $t("MiniDepositAmount") }}:
                                                <b>{{ $env_var.currencyIcon[currency_selected.toUpperCase()] }} {{ (currency_selected.toUpperCase() != 'ZAR') ? checkSuccessDeposit() ? 50 : 50 : checkSuccessDeposit() ? 80 : 800 }} </b>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="parseInt(get_method_id) == 2">
                                <div>
                                    <div class="personalForm list-group mb-3 d-flex justify-content-between align-items-center">
                                        <div class="list-group-item w-100">
                                            <span>{{ $t("depMsz1") }}<strong>{{ $t("depMsz10") }}</strong></span>
                                            <span>{{ $t("depMsz3") }}<strong>{{ $t("depMsz4") }}</strong></span>
                                        </div>
                                    </div>
                                    <div class="personalForm list-group mb-3 d-flex justify-content-between align-items-center">
                                        <div class="list-group-item w-100">
                                            <span>
                                                {{ $t("MiniDepositAmount") }}:
                                                <b>{{ $env_var.currencyIcon[currency_selected.toUpperCase()] }} {{ (currency_selected.toUpperCase() != 'ZAR') ? checkSuccessDeposit() ? 50 : 50 : checkSuccessDeposit() ? 80 : 800 }}</b>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="parseInt(get_method_id) == 18 && ShowAddress && apiCryptoAddress != ''">
                                <div class="position-relative mb-3">
                                    <h4 class="mb-3">{{$t('fxPleaseSelectCurrency')}}</h4>
                                    <div class="customSelectBlock">
                                        <select class="viewAnker" v-model="selectcurrency" name="currency" @change="(getCryptoAddress(selectcurrency), addcrptoCurr = selectcurrency)" v-validate="'required'">
                                            <option value="">{{$t('fxSelectCurrency')}}</option>
                                            <option v-for="(list, index) in crptoJsonNew" :value="list">
                                                {{ handleCryptoList(list) }}
                                            </option>
                                        </select>
                                    </div>
                                    <ul>
                                        <li v-if="errors.has('currency')" class="error">
                                            {{ errors.first('currency') }}
                                        </li>
                                    </ul>
                                </div>
                                <p v-if="selectcurrency != 'BTC'" class="text-danger">
                                    {{$t('fxNoteSelecting')}} {{ !['TRXUSDT', 'TRXUSDC'].includes(selectcurrency) ? 'USDT(ERC20), ETH(ERC20), USDC(ERC20)' : 'USDT(TRC20)' }} {{$t('fxSendFundVia')}} {{ !['TRXUSDT', 'TRXUSDC'].includes(selectcurrency) ? 'ERC' : 'TRC' }} {{$t('fxNetworkYouDeposit')}}
                                </p>
                            </div>
                            <div
                                v-if="get_method_id != '' &&
                                parseInt(get_method_id) == 1 &&
                                Object.keys(withdrawalMethodResponse).length > 0 &&
                                withdrawalMethodResponse.hasOwnProperty(1)
                                "
                            >
                                <h4 class="mb-3" v-if="parseInt(get_method_id) != 1">{{ $t("dep_acc_fund_SpeDepAm") }}</h4>
                                <div class="form-group field-wrapper widthCalc" v-if="get_method_id != 1">
                                    <div class="d-flex mob-wrap">
                                        <div class="position-relative Form-Area mr-2">
                                            <input
                                                placeholder="Amount"
                                                type="text"
                                                v-model="amount"
                                                v-validate="{ required: true, numeric: true }"
                                                name="amount"
                                                class="float-field form-control"
                                                :class="{ 'is-invalid': submitted && errors.has('amount'), }"
                                                ref="amountInput"
                                                autocomplete="off"
                                                @change="handleChangeAmount"
                                            />
                                        </div>
                                        <div
                                            class="SpecifyDeposit d-flex justify-content-start align-items-center p-0"
                                            v-if="get_user.profile.residence_country != 'VN' &&
                                                get_user.profile.residence_country != 'ZA' &&
                                                get_user.profile.residence_country != 'ID'
                                                "
                                            >
                                            <div
                                                :class="amount ==
                                                depositLimitCurrencyWise[
                                                currency_selected.toUpperCase()
                                                ] *
                                                n
                                                ? 'customUserType multiSlct mr-2 selected'
                                                : 'customUserType multiSlct mr-2'
                                                "
                                                v-for="n in 3"
                                            >
                                                <label class="customRadio-button border" @click="amount = depositLimitCurrencyWise[currency_selected.toUpperCase()] * n">
                                                    {{ depositLimitCurrencyWise[currency_selected.toUpperCase()] * n }}
                                                    <input
                                                        type="radio"
                                                        name="radio1"
                                                        :value="depositLimitCurrencyWise[
                                                        currency_selected.toUpperCase()
                                                    ] * n
                                                        "
                                                    />
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <ul>
                                        <li v-for="error in errors.collect('amount')" class="error">
                                            {{ error }}
                                        </li>
                                    </ul>
                                    <p
                                        class="error" v-if="amount_msz_error != '' && parseInt(get_method_id) != 16">
                                        {{ amount_msz_error }}
                                    </p>
                                </div>
                            </div>
                            <div v-if="get_method_id != '' && [5, 3, 2, 18, 23, 24, 25, 26, 27, 31, 32, 33, 37, 38, 39, 40, 41].includes(parseInt(get_method_id))">
                                <div v-if="parseInt(get_method_id) == 24">
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <div class="form-group field-wrapper widthCalc">
                                                <h4 class="mb-3">{{$t('fxPleaseSelectBank')}}</h4>
                                                <div class="customSelectBlock">
                                                    <select class="viewAnker" v-model="addhelp2payBank" name="bank" v-validate="'required'">
                                                        <option value="">{{$t('fxSelectBank')}} </option>
                                                        <option v-for="(item, index) in getHelp2PayBankList[addhelp2payCurr]" :value="item.id">
                                                            {{ item.value }}
                                                        </option>
                                                    </select>
                                                </div>
                                                <ul>
                                                    <li v-if="errors.has('bank')" class="error">
                                                        {{ errors.first('bank') }}
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <h4 class="mb-3">{{ $t("dep_acc_fund_SpeDepAm") }} in <span class="green">{{ currency_selected }}</span></h4>
                                        <div class="form-group field-wrapper widthCalc" v-if="addhelp2payCurr">
                                            <div class="mob-wrap">
                                                <div class="position-relative mr-2">
                                                    <input
                                                        placeholder="Amount"
                                                        type="text"
                                                        v-model="amount"
                                                        v-validate="{ required: true, between: [Math.ceil(amountLimit[addhelp2payCurr].minlength / conversion_unit), parseFloat(amountLimit[addhelp2payCurr].maxlength / conversion_unit).toFixed(2)] }"
                                                        name="amount"
                                                        class="float-field form-control"
                                                        :class="{ 'is-invalid': submitted && errors.has('amount'), }"
                                                        ref="amountInput"
                                                        autocomplete="off"
                                                    />
                                                </div>
                                            </div>
                                            <ul>
                                                <li v-for="error in errors.collect('amount')" class="error">{{ error }}</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="parseInt(get_method_id) == 31">
                                    <h4 class="mb-3">{{ $t("dep_acc_fund_SpeDepAm") }} in <span class="green">{{ currency_selected }}</span></h4>
                                    <div class="form-group field-wrapper widthCalc">
                                        <div class="mob-wrap">
                                            <div class="position-relative mr-2">
                                                <input
                                                    placeholder="Amount"
                                                    type="text"
                                                    v-model="amount"
                                                    name="amount"
                                                    v-validate="{ required: true, between: [Math.ceil(minAmt), parseFloat(maxAmt)] }"
                                                    class="float-field form-control"
                                                    :class="{ 'is-invalid': submitted && errors.has('amount'), }"
                                                    ref="amountInput"
                                                    autocomplete="off"
                                                />
                                            </div>
                                        </div>
                                        <ul>
                                            <li v-for="error in errors.collect('amount')" class="error">{{ error }}</li>
                                        </ul>
                                    </div>
                                </div>
                                <div v-if="parseInt(get_method_id) == 40">
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <div class="form-group field-wrapper widthCalc">
                                                <h4 class="mb-3">{{$t('fxPleaseSelectBank')}}</h4>
                                                <div class="customSelectBlock">
                                                    <select @change="handleChange" class="viewAnker" v-model="addVertupayBank" name="bank" v-validate="'required'">
                                                        <option value="">{{$t('fxSelectBank')}}</option>
                                                        <option 
                                                            v-for="(item, index) in getVertupayList[addVertupayCurr]" 
                                                            :key="index" 
                                                            :value="`${item.id}||${item.pay_method}`"
                                                        >
                                                            {{ item.value }} ({{ item.pay_method }})
                                                        </option>
                                                    </select>
                                                </div>
                                                <ul>
                                                    <li v-if="errors.has('bank')" class="error">
                                                        {{ errors.first('bank') }}
                                                    </li>
                                                </ul>
                                            </div>
                                            <h4 class="mb-3" v-if="showAccountName">Account Name</h4>
                                            <div class="mob-wrap mb-3" v-if="showAccountName">
                                                <div class="position-relative mr-2">
                                                    <input
                                                        placeholder="Account Name"
                                                        type="text"
                                                        v-model="accountName"
                                                        name="accountName"
                                                        class="float-field form-control"
                                                        :class="{ 'is-invalid': submitted && errors.has('accountName') }"
                                                        ref="accountNameInput"
                                                        autocomplete="off"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- <div>
                                        <h4 class="mb-3">{{ $t("dep_acc_fund_SpeDepAm") }} in <span class="green">{{ currency_selected }}</span></h4>
                                        <div class="form-group field-wrapper widthCalc" v-if="addVertupayCurr">
                                            <div class="mob-wrap">
                                                <div class="position-relative mr-2">
                                                    <input
                                                        placeholder="Amount"
                                                        type="text"
                                                        v-model="amount"
                                                        v-validate="{ required: true, between: [Math.ceil(amountLimit[addVertupayCurr].minlength / conversion_unit), parseFloat(amountLimit[addVertupayCurr].maxlength / conversion_unit).toFixed(2)] }"
                                                        name="amount"
                                                        class="float-field form-control"
                                                        :class="{ 'is-invalid': submitted && errors.has('amount'), }"
                                                        ref="amountInput"
                                                        autocomplete="off"
                                                    />
                                                </div>
                                            </div>
                                            <ul>
                                                <li v-for="error in errors.collect('amount')" class="error">{{ error }}</li>
                                            </ul>
                                        </div>
                                    </div> -->
                                </div>
                                <div v-if="parseInt(get_method_id) == 18">
                                    <div v-if="ShowAddress && !apiCryptoAddress">
                                        <div class="form-group field-wrapper widthCalc">
                                            <h4 class="mb-3">{{$t('fxPleaseSelectCurrency')}}</h4>
                                            <div class="customSelectBlock">
                                                <select class="viewAnker" v-model="addcrptoCurr" @change="(getCryptoAddress(addcrptoCurr), selectcurrency = addcrptoCurr)" name="currency" v-validate="'required'">
                                                    <option value="">{{$t('fxSelectCurrency')}}</option>
                                                    <option v-for="(list, index) in crptoJsonNew" :value="list">
                                                        {{ handleCryptoList(list) }}
                                                    </option>
                                                </select>
                                            </div>
                                            <ul>
                                                <li v-if="errors.has('currency')" class="error">
                                                    {{ errors.first('currency') }}
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="form-group field-wrapper widthCalc">
                                            <div class="position-relative Form-Area mr-2 w-100">
                                                <h4 class="mb-2">{{$t('fxWithdrawalWalletAddress')}}</h4>
                                                <input type="text" :value="apiCryptoAddress" class="float-field form-control W-100" v-if="apiCryptoAddress != ''" disabled />
                                                <input
                                                    placeholder=""
                                                    type="text"
                                                    v-model="CryptoAddress"
                                                    v-validate="'required'"
                                                    name="CryptoAddress"
                                                    class="float-field form-control W-100"
                                                    :class="{ 'is-invalid': submitted && errors.has('CryptoAddress'), }"
                                                    ref="CryptoAddressInput"
                                                    v-else
                                                />
                                            </div>
                                            <p v-for="error in errors.collect('CryptoAddress')" class="error">
                                                {{$t('fxEnterCryptoAddress')}}
                                            </p>
                                        </div>
                                        <div class="form-group field-wrapper widthCalc" v-if="apiCryptoAddress == ''">
                                            <p class="text-danger" v-if="addcrptoCurr && addcrptoCurr != 'BTC'">
                                                {{$t('fxNoteSelecting')}} {{ !['TRXUSDT', 'TRXUSDC'].includes(addcrptoCurr) ? 'USDT(ERC20), ETH(ERC20), USDC(ERC20)' : 'USDT(TRC20), USDC(TRC20)' }} {{$t('fxSendFundVia')}} {{ !['TRXUSDT', 'TRXUSDC'].includes(addcrptoCurr) ? 'ERC' : 'TRC' }} {{$t('fxNetworkYouDeposit')}}
                                            </p>
                                            <div class="position-relative Form-Area w-100 mb-2 d-flex">
                                                <input type="checkbox" id="clickMe" v-model="clickMe" name="clickMe" v-validate="'required'" ref="clickMeInput" class="mt-2 mr-3" />
                                                <label for="clickMe">{{ $t('fxIConfirm') }}</label>
                                            </div>
                                            <p v-for="error in errors.collect('clickMe')" class="error">{{ $t('fxFieldRequired') }} </p>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <div class="form-group field-wrapper widthCalc">
                                            <div class="position-relative Form-Area mr-2 w-100">
                                                <h4 class="mb-2">{{$t('fxWithdrawalWalletAddress')}}</h4>
                                                <input type="text" :value="apiCryptoAddress" class="float-field form-control W-100" v-if="apiCryptoAddress != ''" disabled />
                                                <input
                                                    placeholder=""
                                                    type="text"
                                                    v-model="CryptoAddress"
                                                    v-validate="'required'"
                                                    name="CryptoAddress"
                                                    class="float-field form-control W-100"
                                                    :class="{ 'is-invalid': submitted && errors.has('CryptoAddress'), }"
                                                    ref="CryptoAddressInput"
                                                    v-else
                                                />
                                            </div>
                                            <p v-for="error in errors.collect('CryptoAddress')" class="error">{{ $t('fxEnterCryptoAddress') }}</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="clearfix"></div>
                                <h4 class="mb-3" v-if="![1, 24, 31].includes(parseInt(this.get_method_id))">
                                    {{ $t("dep_acc_fund_SpeDepAm") }} in
                                    <span class="green">{{ currency_selected }}</span>
                                </h4>
                                <div class="form-group widthCalc" v-if="![1, 24, 31].includes(parseInt(this.get_method_id))">
                                    <div v-if="(pay_option == 'IX')">
                                        <b>{{$t('fxAmountBRL')}}</b> {{ astropayConvertedAmount }}
                                    </div>
                                    <div class="d-flex mob-wrap">
                                        <div class="position-relative Form-Area mr-md-2">
                                            <input
                                                placeholder="Amount"
                                                type="text"
                                                v-model="amount"
                                                v-validate="{ required: true, numeric: true }"
                                                name="amount"
                                                class="float-field form-control"
                                                :class="{ 'is-invalid': submitted && errors.has('amount'), }"
                                                ref="amountInput"
                                                autocomplete="off"
                                                @input="conversionAmount"
                                            />
                                        </div>
                                        <div class="SpecifyDeposit d-flex justify-content-start align-items-center p-0">
                                            <div :class="amount == 100 ? 'customUserType multiSlct mr-2 selected' : 'customUserType multiSlct mr-2'" @click="conversionAmount">
                                                <label class="customRadio-button border" @click.prevent="amount = 100">
                                                    100 <input type="radio" name="radio1" value="100" />
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                            <div :class="amount == 200 ? 'customUserType multiSlct mr-2 selected' : 'customUserType multiSlct mr-2'" @click="conversionAmount">
                                                <label class="customRadio-button border" @click.prevent="amount = 200">
                                                    200 <input type="radio" name="radio1" value="200" />
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                            <div :class="amount == 500 ? 'customUserType multiSlct mr-2 selected' : 'customUserType multiSlct mr-2'" @click="conversionAmount">
                                                <label class="customRadio-button border" @click.prevent="amount = 500">
                                                    500 <input type="radio" name="radio1" value="500" />
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                            <div :class="amount == 1000 ? 'customUserType multiSlct mr-2 selected' : 'customUserType multiSlct mr-2'" @click="conversionAmount">
                                                <label class="customRadio-button border" @click.prevent="amount = 1000">
                                                    1000
                                                    <input type="radio" name="radio1" value="1000" />
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                            <div :class="amount == 2000 ? 'customUserType multiSlct mr-2 selected' : 'customUserType multiSlct mr-2'" @click="conversionAmount">
                                                <label class="customRadio-button border" @click.prevent="amount = 2000">
                                                    2000
                                                    <input type="radio" name="radio1" value="2000" />
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <ul>
                                        <li v-for="error in errors.collect('amount')" class="error">
                                            {{ error }}
                                        </li>
                                    </ul>
                                    <p class="error" v-if="amount_msz_error != ''">
                                        {{ amount_msz_error }}
                                    </p>
                                </div>
                                <template v-if="pay_option == 'IX' && !$store.state.user.profile.astro_cpf_no">
                                    <div class="row row-marginmob">
                                        <div class="col-6 pb-2">
                                            <div class="funding-input pb-3 pb-md-0 Form-Area w-100">
                                                <input
                                                    placeholder="Enter your 11 digit CPF"
                                                    type="text"
                                                    v-model="astro_cpf_no"
                                                    v-validate="{ required: true, numeric: true, min: 11, max:11 }"
                                                    name="astro_cpf_no"
                                                    class="float-field form-control"
                                                    :class="{ 'is-invalid': submitted && errors.has('astro_cpf_no'), }"
                                                    ref="astro_cpf_no_Input"
                                                    @input="documentValidation"
                                                />
                                                <p class="error" v-for="error in errors.collect('astro_cpf_no')">
                                                    {{ error }}
                                                </p>
                                                <p class="error" v-if="doc_error">{{$t('fxInvalidCPFNumber')}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </div>
                            <p v-if="get_method_id != '' && get_method_id != 1 && parseInt(get_user.verified_status) == 1 && parseInt(get_method_id) != 24" class="text-danger">{{ $t('fxInOrder') }}</p>
                            <div class="clearfix"></div>
                            <div class="bitNotes" v-if="parseInt(get_method_id) == 18">
                                <p>{{ $t('fxFollowingDepositPoint') }}</p>
                                <ul class="desText">
                                    <li>{{ $t('fxDepositPoint1') }} </li>
                                    <li>{{ $t('fxDepositPoint2') }}</li>
                                    <li>{{ $t('fxDepositPoint3') }}</li>
                                    <li>{{ $t('fxDepositPoint4') }}</li>
                                    <li>{{ $t('fxDepositPoint5') }}</li>
                                    <li>{{ $t('fxDepositPoint6') }}</li>
                                    <li>{{ $t('fxDepositPoint7') }}</li>
                                </ul>
                            </div>
                            <p class="error" v-if="raised_max_limit_msg != ''">
                                {{ raised_max_limit_msg }}
                            </p>
                            <div class="submitButton d-flex justify-content-between align-items-center w-100 mt-2 text-center" v-if="parseInt(get_method_id) != 1">
                                <a
                                    class="d-flex align-items-center"
                                    href="#"
                                    v-on:click.stop.prevent="reset(); shwStep = 1;"
                                >
                                    <feather class="mr-1" type="chevron-left"></feather>
                                    {{ $t("dep_acc_fund_bakStp") }}
                                </a>
                                <button
                                    class="prism_btn btn_sm"
                                    v-on:click.stop.prevent="validateValue()"
                                    :class="disabledProced ? 'disabled' : ''"
                                    v-if="get_method_id != '' && ((parseInt(get_method_id) == 1 && Object.keys(withdrawalMethodResponse).length > 0 && withdrawalMethodResponse.hasOwnProperty(1)) || parseInt(get_method_id) == 3 || parseInt(get_method_id) == 2 || parseInt(get_method_id) == 18 || parseInt(get_method_id) == 37 || parseInt(get_method_id) == 38 || parseInt(get_method_id) == 39 || parseInt(get_method_id) == 40 || parseInt(get_method_id) == 41 || parseInt(get_method_id) == 23 || parseInt(get_method_id) == 24 || parseInt(get_method_id) == 25 || parseInt(get_method_id) == 26 || parseInt(get_method_id) == 27 || parseInt(get_method_id) == 31 || parseInt(get_method_id) == 32 || (parseInt(get_method_id) != 1 && parseInt(get_method_id) != 3 && parseInt(get_method_id) != 2))"
                                >
                                    {{ $t("dep_acc_fund_procToPay") }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="costompopup pop_xs fundNow1 DemoCustom" v-if="increaseDepositLimit">
                <div class="whiteBG costompopupBox">
                    <div class="modal-header border-0 pt-3 pl-3 position-relative">
                        <h3 class="modal-title" v-if="trans_id == ''">
                            {{$t('fxYourDepositLimit')}} {{ get_user.crypto_limit }}
                        </h3>
                        <button type="button" class="close" @click.prevent="increaseDepositLimit = false; trans_id = '';">
                            &times;
                        </button>
                    </div>
                    <div class="modal-body p-3">
                        <message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
                        <div class="mt-2 middleBox" v-if="trans_id != ''">
                            <app-OptVerfication :transaction_id="trans_id" :module="''" :title_parent="0" :data="''" :ticketRequestFrom="'increase-Limit'" :accountId="''"></app-OptVerfication>
                        </div>
                        <div class="text-center" v-else>
                            <p>{{$t('fxDoWantIncrease')}}</p>
                            <div class="text-center pt-3 mb-3">
                                <a href="#" class="prism_btn btn_xs" @click.prevent="IncreaseLimitOtp()">{{$('fxYes')}}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="" v-if="shwStep == 3">
                <app-opt-verfication :transaction_id="trans_id" :module="'120'" :title_parent="'0'" :data="''" :ticketRequestFrom="'bankDeposit'" :accountId="account_id" v-if="trans_id != '' && !congModule"></app-opt-verfication>
                <div class="mt-2" v-if="congModule">
                    <div class="row no-gutters justify-content-center">
                        <div class="whiteBG p-4 middleBox">
                            <div class="congratulations">
                                <div class="logo_congrats">
                                    <img src="../../../../static/fxView/images/congrats.png" alt="Icon" />
                                </div>
                                <div class="subtitle">
                                    <h3>{{ $t("rb_congo") }}<span class="green">{{ get_user.username }}</span></h3>
                                    <p>{{ $t("dep_ticketHasbeenCreated") }}</p>
                                </div>
                            </div>
                            <div class="signupbtn full-width submitButton w-100 mt-4 text-center">
                                <router-link
                                    :to="{
                                    name: 'fxView.support',
                                    params: { tabName: 'openRequest' },
                                }"
                                    class="prism_btn btn_sm"
                                >
                                    {{ $t("dep_proMsz19") }}
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <form action="https://pay.skrill.com" method="post" target="_self" id="skrillForm">
                <div class="CustomBlockWidth inMiddle-area whitebox p-4" v-show="shwStep == 7">
                    <div class="confirmPayment">
                        <h3 class="mb-3">{{ $t("PleaseEnsureCorrect") }}</h3>
                        <div class="table-responsive">
                            <table class="table w-100 mb-5">
                                <thead>
                                    <tr>
                                        <th>{{ $t("accountId") }}</th>
                                        <th>{{ $t("feeUsd") }}</th>
                                        <th>{{ $t("depositAmount") }}</th>
                                        <th>{{ $t("paymentMethod") }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{{ account_id }}</td>
                                        <td>0</td>
                                        <td>{{ amount }}</td>
                                        <td>{{ $env_var.depositMethodShow[get_method_id] }}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <p v-if="get_method_id != '' && parseInt(get_user.verified_status) == 1" class="text-danger">{{$t('fxInOrder')}}</p>
                        </div>
                    </div>
                    <input type="hidden" name="pay_to_email" value="backoffice@fxview.com" />
                    <input type="hidden" name="pay_from_email" :value="get_user.email" />
                    <input type="hidden" name="status_url" value="https://globaltps.fxview.com/payment/resp" />
                    <input type="hidden" name="return_url" :value="$env_var.depositLink" />
                    <input type="hidden" name="firstname" :value="get_user.profile.firstname" />
                    <input type="hidden" name="lastname" :value="get_user.profile.lastname" />
                    <!-- <input type="hidden" name="merchant_id" value="169238422" /> -->
                    <!-- Old merchant id  -->
                    <input type="hidden" name="merchant_id" value="210278473" />
                    <!-- New merchant id  -->
                    <input type="hidden" name="language" value="EN" />
                    <input type="hidden" name="amount" :value="amount" />
                    <input type="hidden" name="currency" :value="currency_selected" />
                    <input type="hidden" name="payment_methods" :value="pay_option" />
                    <input type="hidden" name="email" :value="get_user.email" />
                    <input type="hidden" name="merchant_fields" value="tradingAccount,email,method_id" />
                    <input type="hidden" name="tradingAccount" :value="account_id" />
                    <input type="hidden" name="method_id" :value="get_method_id" />
                    <input type="hidden" name="return_url_target" value="3" />
                    <input type="hidden" name="cancel_url_target" value="3" />
                    <input type="hidden" name="transaction_id" :value="transaction_id" />
                    <input type="hidden" name="detail1_description" :value="'Deposit in ' + account_id" />
                    <input type="hidden" name="detail1_text" value="Payment for account id" />
                    <div class="submitButton d-flex justify-content-between align-items-center w-100 mt-2 text-center">
                        <a class="d-flex align-items-center" href="#" v-on:click.stop.prevent="shwStep = 2">
                            <feather class="mr-1" type="chevron-left"></feather>
                            {{ $t("backToStep") }}
                        </a>
                        <button class="prism_btn btn_sm" v-on:click.stop.prevent="getTransactionId()">
                            {{ $t("procToPay") }}
                        </button>
                    </div>
                </div>
            </form>
            <div class="CustomBlockWidth inMiddle-area whitebox p-4" v-show="shwStep == 6">
                <div class="confirmPayment">
                    <h3 class="mb-3">{{ $t("conPay") }}</h3>
                    <p class="mb-5">{{ $t("depMsz15") }}</p>
                    <div class="table-responsive">
                        <table class="table w-100 mb-5">
                            <thead>
                                <tr>
                                    <th>{{ $t("accountId") }}</th>
                                    <th>{{ $t("feeUsd") }}</th>
                                    <th>{{ $t("depositAmount") }}</th>
                                    <th>{{ $t("paymentMethod") }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{{ account_id }}</td>
                                    <td>0</td>
                                    <td>{{ amount }}</td>
                                    <td>{{ $env_var.depositMethodShow[get_method_id] }}</td>
                                </tr>
                            </tbody>
                        </table>
                        <p v-if="get_method_id != '' && parseInt(get_user.verified_status) == 1" class="text-danger">{{$t('fxInOrder')}}</p>
                    </div>
                </div>
                <div class="submitButton d-flex justify-content-between align-items-center w-100 mt-2 text-center">
                    <a class="d-flex align-items-center" href="#" v-on:click.stop.prevent="shwStep = 2">
                        <feather class="mr-1" type="chevron-left"></feather>
                        {{ $t("backToStep") }}
                    </a>
                    <button class="prism_btn btn_sm" @click="getTransactionId()">
                        {{ $t("procToPay") }}
                    </button>
                </div>
            </div>
            <div class="CustomBlockWidth inMiddle-area whitebox p-4" v-show="shwStep == 8">
                <div class="confirmPayment">
                    <h3 class="mb-3">{{ $t("conPay") }}</h3>
                    <p class="mb-5">{{ $t("depMsz15") }}</p>
                    <div class="table-responsive">
                        <table class="table w-100 mb-5">
                            <thead>
                                <tr>
                                    <th>{{ $t("accountId") }}</th>
                                    <th>{{ $t("feeUsd") }}</th>
                                    <th>{{ $t("depositAmount") }}</th>
                                    <th>{{ $t("paymentMethod") }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{{ account_id }}</td>
                                    <td>0</td>
                                    <td>{{ amount }}</td>
                                    <td>{{ $env_var.depositMethodShow[get_method_id] }}</td>
                                </tr>
                            </tbody>
                        </table>
                        <p v-if="get_method_id != '' && parseInt(get_user.verified_status) == 1" class="text-danger">{{$t('fxInOrder')}}</p>
                    </div>
                </div>
                <div class="submitButton d-flex justify-content-between align-items-center w-100 mt-2 text-center">
                    <a class="d-flex align-items-center" href="#" v-on:click.stop.prevent="shwStep = 2">
                        <feather class="mr-1" type="chevron-left"></feather>
                        {{ $t("backToStep") }}
                    </a>
                    <button class="prism_btn btn_sm" @click="getUrlForPraxis()">
                        {{ $t("procToPay") }}
                    </button>
                </div>
            </div>
            <div class="CustomBlockWidth inMiddle-area whitebox p-4" v-show="shwStep == 15">
                <div class="confirmPayment">
                    <h3 class="mb-3">{{ $t("conPay") }}</h3>
                    <p class="mb-5">{{$t('fxEnsure')}} {{ cryptoConfJson[selectcurrency] }} {{$t('fxMarketPrice')}}.</p>
                    <div class="table-responsive">
                        <table class="table w-100 mb-2">
                            <thead>
                                <tr>
                                    <th>{{ $t("accountId") }}</th>
                                    <th>{{ $t("feeUsd") }}</th>
                                    <th>{{ $t("depositAmount") }}</th>
                                    <th>{{ $t("paymentMethod") }}</th>
                                    <th>{{ currencyObject[selectcurrency] }} {{$t('fxAmount')}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{{ account_id }}</td>
                                    <td>0</td>
                                    <td>{{ amount }}</td>
                                    <td>{{ selectcurrency }}</td>
                                    <!-- $env_var.depositMethodShow[get_method_id] -->
                                    <td>{{ bitcoinConversionData.converted_amount }}</td>
                                </tr>
                            </tbody>
                        </table>
                        <p class="text-danger" v-if="selectcurrency != 'BTC'">
                            {{$t('fxNoteSelecting')}} {{ !['TRXUSDT', 'TRXUSDC'].includes(selectcurrency) ? 'USDT(ERC20), ETH(ERC20), USDC(ERC20)' : 'USDT(TRC20), USDC(TRC20)' }} {{$t('fxSendFundVia')}} {{ !['TRXUSDT', 'TRXUSDC'].includes(selectcurrency) ? 'ERC' : 'TRC' }} {{$t('fxNetworkYouDeposit')}}
                        </p>
                        <p v-if="get_method_id != '' && parseInt(get_user.verified_status) == 1" class="text-danger">{{$t('fxInOrder')}}</p>
                    </div>
                </div>
                <div class="submitButton d-flex justify-content-between align-items-center w-100 mt-2 text-center">
                    <a class="d-flex align-items-center" href="#" v-on:click.stop.prevent="shwStep = 2">
                        <feather class="mr-1" type="chevron-left"></feather>
                        {{ $t("backToStep") }}
                    </a>
                    <button class="prism_btn btn_sm" @click="cryptDepositFunc()">{{$t('fxPayNow')}}</button>
                </div>
            </div>
            <div class="CustomBlockWidth inMiddle-area whitebox p-4" v-show="shwStep == 16">
                <div class="stepForm middleBox">
                    <div class="whiteBG p-3">
                        <h2 class="d-flex justify-content-center p-3">
                            {{ currencyObject[selectcurrency] }} {{$t('fxAddress')}}
                        </h2>
                        <div class="d-flex justify-content-center p-3 qr-CodeImage">
                            <vue-qrcode :value="cryptoDepositAddress" />
                        </div>
                        <div class="alert text-center pt-3 CouponCode d-flex justify-content-center">
                            <div class="copied" v-if="copyText == cryptoDepositAddress">
                                <p>{{ showcopymsz }}</p>
                            </div>
                            <p class="cyrptAddress d-flex">
                                <span class="float-left cyrptTitle">{{ cryptoDepositAddress }}</span>
                                <span class="copyIcon" v-clipboard:copy="cryptoDepositAddress" v-clipboard:success="onCopy" v-clipboard:error="onError">
                                    <feather type="copy"></feather>
                                </span>
                            </p>
                        </div>
                        <div class="box_space text-center p-4">
                            <div class="deposit_lastsec text-left">
                                <div class="crypto_addsec text-center">
                                    <h3>{{$t('fxSendOnly')}} {{ currencyObject[selectcurrency] }} {{$t('fxDepositAddress')}}</h3>
                                    <p>{{$t('fxTradingAccount')}} <strong>{{ account_id }}</strong> {{$t('fxOnceReceiveMoney')}}</p>
                                    <p class="text-danger" v-if="selectcurrency != 'BTC'">
                                        {{$t('fxNoteSelecting')}} {{ !['TRXUSDT', 'TRXUSDC'].includes(selectcurrency) ? 'USDT(ERC20), ETH(ERC20), USDC(ERC20)' : 'USDT(TRC20), USDC(TRC20)' }} {{$t('fxSendFundVia')}} {{ !['TRXUSDT', 'TRXUSDC'].includes(selectcurrency) ? 'ERC' : 'TRC' }} {{$t('fxNetworkYouDeposit')}}
                                    </p>
                                    <p v-if="get_method_id != '' && parseInt(get_user.verified_status) == 1" class="text-danger">{{$t('fxInOrder')}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="submitButton d-flex justify-content-between align-items-center w-100 mt-2 text-center">
                    <a class="d-flex align-items-center" href="#" v-on:click.stop.prevent="backQr()">
                        <feather class="mr-1" type="chevron-left"></feather>
                        {{ $t("backToStep") }}
                    </a>
                </div>
            </div>
            <div class="CustomBlockWidth" v-show="shwStep == 5">
                <div class="row justify-content-center">
                    <div class="middleBox">
                        <div class="whiteBG p-3">
                            <div class="confirmPayment">
                                <h3 class="mb-3">{{ $t("dep_acc_fund_PlsEnsCort") }}</h3>
                                <div class="table-responsive">
                                    <table class="table w-100 mb-5">
                                        <thead>
                                            <tr>
                                                <th>{{ $t("dep_acc_fund_accountId") }}</th>
                                                <th>{{ $t("dep_acc_fund_feeUsd") }}</th>
                                                <th>{{ $t("dep_acc_fund_depAmt") }}</th>
                                                <th>{{ $t("dep_acc_fund_depMeth") }}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>{{ account_id }}</td>
                                                <td>0</td>
                                                <td>{{ amount }}</td>
                                                <td>{{ $env_var.depositMethodShow[get_method_id] }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <p v-if="get_method_id != '' && parseInt(get_user.verified_status) == 1" class="text-danger">{{$t('fxInOrder')}}</p>
                                </div>
                            </div>
                            <div class="submitButton d-flex justify-content-between align-items-center w-100 mt-2 text-center">
                                <a class="d-flex align-items-center" href="#" v-on:click.stop.prevent="shwStep = 2">
                                    <feather class="mr-1" type="chevron-left"></feather>
                                    {{ $t("dep_acc_fund_bakStp") }}
                                </a>
                                <button class="prism_btn btn_sm" @click.prevent="creditCardDepositFunc()">
                                    {{ $t("dep_acc_fund_procToPay") }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="CustomBlockWidth" v-show="shwStep == 32">
                <div class="row justify-content-center">
                    <div class="middleBox">
                        <div class="whiteBG p-3">
                            <div class="confirmPayment">
                                <h3 class="mb-3">{{ $t("dep_acc_fund_PlsEnsCort") }}</h3>
                                <div class="table-responsive">
                                    <table class="table w-100 mb-5">
                                        <thead>
                                            <tr>
                                                <th>{{ $t("dep_acc_fund_accountId") }}</th>
                                                <th>{{ $t("dep_acc_fund_feeUsd") }}</th>
                                                <th>{{ $t("dep_acc_fund_depAmt") }}</th>
                                                <th>{{ $t("dep_acc_fund_depMeth") }}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>{{ account_id }}</td>
                                                <td>0</td>
                                                <td>{{ amount }}</td>
                                                <td>{{ $env_var.depositMethodShow[get_method_id] }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <p v-if="get_method_id != '' && parseInt(get_user.verified_status) == 1" class="text-danger">{{$t('fxInOrder')}}</p>
                                </div>
                            </div>
                            <div class="submitButton d-flex justify-content-between align-items-center w-100 mt-2 text-center">
                                <a class="d-flex align-items-center" href="#" v-on:click.stop.prevent="shwStep = 2">
                                    <feather class="mr-1" type="chevron-left"></feather>
                                    {{ $t("dep_acc_fund_bakStp") }}
                                </a>
                                <button class="prism_btn btn_sm" @click.prevent="creditNuveiDepositFunc()">
                                    {{ $t("dep_acc_fund_procToPay") }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="CustomBlockWidth" v-show="[37, 38, 39].includes(parseInt(shwStep))">
                <div class="row justify-content-center">
                    <div class="middleBox">
                        <div class="whiteBG p-3">
                            <div class="confirmPayment">
                                <h3 class="mb-3">{{ $t("dep_acc_fund_PlsEnsCort") }}</h3>
                                <div class="table-responsive">
                                    <table class="table w-100 mb-5">
                                        <thead>
                                            <tr>
                                                <th>{{ $t("dep_acc_fund_accountId") }}</th>
                                                <th>{{ $t("dep_acc_fund_feeUsd") }}</th>
                                                <th>{{ $t("dep_acc_fund_depAmt") }}</th>
                                                <th>{{ $t("dep_acc_fund_depMeth") }}</th>
                                                <th>{{ korapayCurrencyList[korapayCurrency] }} {{$t('fxAmount')}}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>{{ account_id }}</td>
                                                <td>0</td>
                                                <td>{{ amount }}</td>
                                                <td>{{ $env_var.depositMethodShow[get_method_id] }}</td>
                                                <td>{{ korapayConvertedData.converted_amount }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <p v-if="get_method_id != '' && parseInt(get_user.verified_status) == 1" class="text-danger">{{ $t('fxInOrder') }}</p>
                                </div>
                            </div>
                            <div class="submitButton d-flex justify-content-between align-items-center w-100 mt-2 text-center">
                                <a class="d-flex align-items-center" href="#" v-on:click.stop.prevent="shwStep = 2">
                                    <feather class="mr-1" type="chevron-left"></feather>
                                    {{ $t("dep_acc_fund_bakStp") }}
                                </a>
                                <button class="prism_btn btn_sm" @click.prevent="handleKorapayDeposit()">
                                    {{ $t("dep_acc_fund_procToPay") }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="loaderOverlayFull" v-if="qr_image">
                <div class="loaderContent">
                    <div style="margin-bottom: 20px;">
                        <div class="addressBox d-flex align-items-center flex-column flex-md-row justify-content-between">
                            <strong class="mr-md-3 mb-2 mb-md-0">{{ qr }}</strong>
                            <div class="btn-wrap">
                                <button class="copy prism_btn btn_sm" type="button" @click="copy(qr)">{{$t('fxCopy')}}</button>
                                <p class="copytext" v-show="copyMsg != ''">{{ copyMsg }}</p>
                            </div>
                        </div>
                        <img :src="'data:image/png;base64,' + qr_image" />
                    </div>
                    <button type="button" class="prism_btn btn_sm" @click="doneAstrorequest()">{{ $t('fxDone') }}</button>
                </div>
            </div>
        </div>
        <div v-else-if="tradingAccountList.totalLiveAccounts == 0">
            <div class="mainTitle text-center my-3">
                <h3>{{ $t("dep_acc_fund_noTrdAccFnd") }}</h3>
            </div>
            <no-trading-account :demo_live_both="''" :totalRecords="tradingAccountList.totalLiveAccounts"></no-trading-account>
        </div>
        <div class="row d-flex justify-content-center" v-if="shwStep == -4">
            <div class="stepForm middleBox">
                <div class="whiteBG p-3">
                    <h2 class="d-flex justify-content-center p-3">
                        {{ currencyObject[selectcurrency] }} {{$t('fxAddress')}}
                    </h2>
                    <div class="d-flex justify-content-center p-3 qr-CodeImage">
                        <vue-qrcode :value="cyrptAddress" />
                    </div>
                    <div class="alert text-center pt-3 CouponCode d-flex justify-content-center">
                        <div class="copied" v-if="copyText == cyrptAddress">
                            <p>{{ showcopymsz }}</p>
                        </div>
                        <p class="cyrptAddress d-flex">
                            <span class="float-left cyrptTitle">{{ cyrptAddress }}</span>
                            <span class="copyIcon" v-clipboard:copy="cyrptAddress" v-clipboard:success="onCopy" v-clipboard:error="onError">
                                <feather type="copy"></feather>
                            </span>
                        </p>
                    </div>
                    <div class="box_space text-center p-4">
                        <div class="deposit_lastsec text-center">
                            <div class="crypto_addsec text-center">
                                <h3>{{$t('fxSendOnly')}} {{ currencyObject[selectcurrency] }} {{$t('fxDepositAddress')}}</h3>
                                <p>{{$t('fxTradingAccount')}} <strong>{{ account_id }}</strong> {{$t('fxOnceReceiveMoney')}}</p>
                                <p class="text-danger" v-if="selectcurrency != 'BTC'">
                                    {{$t('fxNoteSelecting')}} {{ !['TRXUSDT', 'TRXUSDC'].includes(selectcurrency) ? 'USDT(ERC20), ETH(ERC20), USDC(ERC20)' : 'USDT(TRC20), USDC(TRC20)' }} {{$t('fxSendFundVia')}} {{ !['TRXUSDT', 'TRXUSDC'].includes(selectcurrency) ? 'ERC' : 'TRC' }} {{$t('fxNetworkYouDeposit')}}
                                </p>
                                <p v-if="get_method_id != '' && parseInt(get_user.verified_status) == 1" class="text-danger">{{$t('fxInOrder')}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal -->
        <div class="modal show extra" id="exampleModalCenterotp" v-if="this.get_user.is_email_verified === 0">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-body">
                        <div class="otpBlock text-center">
                            <img width="80" class="" src="../../../../static/fxView/images/email.svg" />
                            <p class="mb-3">{{$t('fxOTPText')}}</p>
                            <div class="otp-inputs list-unstyled d-flex align-items-center justify-content-center mb-3">
                                <v-otp-input
                                    ref="otpInput"
                                    input-classes="otp-input"
                                    separator="-"
                                    v-model="otp"
                                    :num-inputs="6"
                                    :should-auto-focus="true"
                                    :is-input-num="true"
                                    @on-change="handleOnChange"
                                    @on-complete="handleOnComplete"
                                />
                            </div>
                            <span class="error">{{ msg }}</span>
                        </div>
                    </div>
                    <div class="modal-footer border-top-0 justify-content-center py-2">
                        <button type="button" class="prism_btn btn-sm" @click.prevent="verify_registered_email()">{{$t('fxSubmit')}}</button>
                    </div>
                    <div class="modal-footer justify-content-center">
                        <p class="mb-0">{{$t('fxPlease')}} <a href="#" @click.prevent="resend_email()">{{$t('fxclickhere')}}</a> {{$t('fxResendOTP')}}</p>
                    </div>
                    <p class="text-center"><router-link :to="'/dashboard'" @click="clearOtpInput()">{{$t('fxGoToDashboard')}}</router-link></p>
                </div>
            </div>
        </div>
        <div class="modal-backdrop fade show" v-if="this.get_user.is_email_verified == 0"></div>
    </div>
    
</template>

<script>
    // import VueQrcode from 'vue-qrcode'
    import { fxViewMixins } from "@/plugins/fxView";
    import { Const } from "@/plugins/fxView/provider/candle-history/lib/const.cls";
    import optVerfication from "../supports/services/otp_verification";
    import moment from "moment";
    import VueQrcode from "vue-qrcode";
    import * as types from "@/types";
    import { mapActions } from "vuex";
    import axios from "axios";

    export default {
        name: "Deposit",
        mixins: [fxViewMixins],
        data() {
            return {

                get_payment_obj : {},
                allow_Crypto_user:[1173],
                PaymentMethodList: [],
                //============message and loader ===========
                qr_image: null,
                qr: null,
                copyMsg: "",
                response_msg: "",
                msg_type: "",
                doc_error: "",
                pageLoader: false,
                currencyTab: false,
                loaderFuncRun: "1",
                //==========================================
                currencyList: "",
                // help2payFormData: "",
                account_id: "",
                act_account_id: "",
                amount: "",
                astro_cpf_no: "",
                countrycode: "+55",
                // phone: "",
                document_type: "CPF",
                conversion_unit: 1,
                submitted: false,
                shwOption: true,
                shwStep: 1,
                account_number: "",
                pay_option: "",
                description: "Payment for account id",
                get_method_id: "",
                currency_selected: "",
                method_id: "",
                transaction_id: "-1",
                showIndex: "-1",
                showIndex1: "1",
                crptoJson: {
                    "1": "BTC",
                    "2": "USDT",
                    "3": "ETH",
                    "4": "USDC",
                },
                crptoJsonNew: {
                    "1": "BTC",
                    "2": "USDT",
                    "3": "ETH",
                    "4": "USDC",
                    "5": "TRXUSDT",
                    // "6": "TRXUSDC",
                },
                selectcurrency: "BTC",
                addcrptoCurr: "",
                disabledProced: false,
                disableCC: true,
                otp: '',

                responseTransLimitDataNew: {
                    1: { MONTHLY: "25000", DAILY: "15000", PERTXN: "5000" },
                    2: { MONTHLY: "25000", DAILY: "15000", PERTXN: "5000" },
                    3: { MONTHLY: "25000", DAILY: "15000", PERTXN: "5000" },
                    4: { MONTHLY: "25000", DAILY: "15000", PERTXN: "5000" },
                    5: { MONTHLY: "25000", DAILY: "15000", PERTXN: "5000" },
                    6: { MONTHLY: "25000", DAILY: "15000", PERTXN: "5000" },
                    7: { MONTHLY: "25000", DAILY: "15000", PERTXN: "5000" },
                    8: { MONTHLY: "25000", DAILY: "15000", PERTXN: "5000" },
                    17: { MONTHLY: "25000", DAILY: "15000", PERTXN: "5000" },
                    18: { MONTHLY: "25000", DAILY: "100000", PERTXN: "100000" },
                    23: { MONTHLY: "25000", DAILY: "15000", PERTXN: "5000" },
                    25: { MONTHLY: "25000", DAILY: "15000", PERTXN: "5000" },
                    24: { MONTHLY: "25000", DAILY: "15000", PERTXN: "5000" },
                    26: { MONTHLY: "25000", DAILY: "15000", PERTXN: "5000" },
                    27: { MONTHLY: "25000", DAILY: "15000", PERTXN: "5000" },
                    31: { MONTHLY: "25000", DAILY: "50000", PERTXN: "50000" },
                    32: { MONTHLY: "50000", DAILY: "50000", PERTXN: "50000" },
                    33: { MONTHLY: "25000", DAILY: "15000", PERTXN: "5000" },
                    37: { MONTHLY: "25000", DAILY: "15000", PERTXN: "5000" },
                    38: { MONTHLY: "25000", DAILY: "15000", PERTXN: "5000" },
                    39: { MONTHLY: "25000", DAILY: "15000", PERTXN: "5000" },
                    40: { MONTHLY: "25000", DAILY: "15000", PERTXN: "5000" },
                    41: { MONTHLY: "25000", DAILY: "15000", PERTXN: "5000" },
                },
                MinValue: "",
                depositMinAllowedValue: {
                    1: { min_amount: 500 },
                    2: { min_amount: 50 },
                    3: { min_amount: 50 },
                    5: { min_amount: 50 },
                    6: { min_amount: 50 },
                    7: { min_amount: 50 },
                    8: { min_amount: 50 },
                    9: { min_amount: 50 },
                    10: { min_amount: 50 },
                    17: { min_amount: 50 },
                    18: { min_amount: 50 },
                    25: { min_amount: 50 },
                    24: { min_amount: 50 },
                    26: { min_amount: 50 },
                    27: { min_amount: 50 },
                    31: { min_amount: 50 },
                    32: { min_amount: 50 },
                    33: { min_amount: 50 },
                    37: { min_amount: 50 },
                    38: { min_amount: 50 },
                    39: { min_amount: 50 },
                    40: { min_amount: 50 },
                    41: { min_amount: 50 },
                },
                cryptoConfJson: {
                    BTC: "BTCUSD",
                    USDT: "USDTUSD",
                    ETH: "ETHUSD",
                    USDC: "USDCUSD",
                },

                // trans_id: '',
                increaseDepositLimit: false,

                copy_msg1: false,

                cryptoDepositAddress: "",
                cyrptAddress: "",
                cryptoMethods: {
                    BTC: "18",
                    LTC: "19",
                    BCH: "20",
                },
                currencyObject: {
                    BTC: "Bitcoin",
                    LTC: "LiteCoin",
                    BCH: "Bitcoin Cash",
                    USDT: "USDT",
                    ETH: "Etherum",
                    USDC: "USDC",
                    /*"ETH": "Etherum (ETH Network)",
                "TUSD": "True USD (ETH Network)",
                "USDC": "USDC (ETH Network)",
                "ALGO": "Algorand",
                "REP": "Augur",
                "bat": "Basic Attention Token",
                "BSV": "Bitcoin SV",
                "LINK": "Chainlink",
                "BNT": "Bancor",
                "COMP": "Compound",
                "cro": "Crypto.com Coin",
                "USDT": "Tether (ERC 20 Address)",
                "dai": "DAI",
                "enj": "Enjin Coin",
                "eos": "EOS",
                "ZIL": "zilliqa",
                "UNI": "Uniswap"*/
                },
                accountName: '',
                showAccountName: false,
                addVertupayCurr: "",
                addVertupayBank: "",
                addhelp2payCurr: "",
                addhelp2payBank: "",
                korapayCurrency: "",
                korapayCurrencyList: {},
                korapayConvertedData: {},
                // korapayMethods: {},
                getCurrencyCode: {
                    THB: "THB",
                    MYR: "MYR",
                    IDR: "IDR",
                    VND: "VND",
                    PHP: "PHP",
                    USD: "USD",
                },

                raised_max_limit_msg: "",
                amount_msz_error: "",

                dp_mtd_show_acc_User_res_con: {
                    SE: [8, 9],
                    DE: [6, 8, 10],
                    PL: [7, 8],
                    BE: [8, 10],
                    IT: [8, 10],
                    NL: [8, 10],
                    ES: [8, 10],
                    AT: [8, 10],
                    BG: [8],
                    DK: [8],
                    EE: [8],
                    FI: [8],
                    FR: [8],
                    GR: [8],
                    HU: [8],
                    LV: [8],
                    PT: [8],
                    NO: [8],
                },

                depositValue: {
                    1: "1",
                    2: "WLT",
                    3: "NTL",
                    5: "CC",
                    6: "GIR",
                    7: "PWY",
                    8: "OBT",
                    9: "EBT",
                    10: "SFT",
                    17: "17",
                    18: "BTC",
                    23: "Paysafe",
                    25: "Swiffy",
                    24: "Help2Pay",
                    26: "Payguru",
                    27: "AstroPay",
                    // 31: "PerfectMoney",
                    32: "CC",
                    33: "TrustPay",
                    // 37: "Korapay",
                    37: "card",
                    38: "bank_transfer",
                    39: "mobile_money",
                    40: "Vertupay",
                    41: "Payment Asia",
                },

                bankData: "",
                trans_id: "",
                congModule: false,

                depositLimitCurrencyWise: {
                    AUD: 500,
                    GBP: 500,
                    EUR: 500,
                    USD: 500,
                    ZAR: 500,
                },
                limit: 50,
                payment_method_acc_to_country: {
                    VN: "fxview-bank-vn-d",
                    ZA: "fxview-ozow-za-d",
                    ID: "fxview-bank-id-d",
                },
                SACountries: ["ZA", "LS", "NA"],

                copyText: "",
                showcopymsz: "",
                bitcoinConversionData: {},
                depositCurrency: "",
                apiCryptoAddress: "",
                CryptoAddress: "",
                ShowAddress: false,
                clickMe: false,
                userCountry: "N/A",
                astroPayID: "",
                astropayConvertedAmount: '',
                timeout: null,
                error:'',
                msg:'',
                
                // nuveiData: '',
                //v-if="getUserProfile.residence_country == 'PL'"
            };
        },
        components: {
            appOptVerfication: optVerfication,
            VueQrcode,
        },
        computed: {
            minAmt() {
                this.conversion_unit = (this.convertedCurrencies[this.currency_selected] || {})["USD"] || 1;
                if ([31].includes(parseInt(this.get_method_id)) && this.currency_selected.toUpperCase() == "ZAR") {
                    if (this.checkSuccessDeposit()) {
                        this.depositMinAllowedValue[parseInt(this.get_method_id)].min_amount = 80;
                    } else {
                        this.depositMinAllowedValue[parseInt(this.get_method_id)].min_amount = 800;
                    }
                }
                return parseFloat(this.depositMinAllowedValue[this.get_method_id].min_amount / this.conversion_unit).toFixed(2);
            },
            maxAmt() {
                this.conversion_unit = (this.convertedCurrencies[this.currency_selected] || {})["USD"] || 1;
                return parseInt(this.responseTransLimitDataNew[this.get_method_id].DAILY / this.conversion_unit).toFixed(2);
            },
            OnlyUsers() {
                // Only User
                // const getuser = [12832, 12829, 1173, 50825, 50734, 45249, 43521, 62330, 50956, 65084].includes(this.get_user.profile.user_id);
                const getuser = [].includes(this.get_user.profile.user_id);
                return getuser;
            },
            
        },
        watch: {
            get_method_id: function (val) {
                if ([5, 3, 2, 17, 18, 23, 24, 25, 26, 27, 31, 32, 33, 37, 38, 39, 40, 41].includes(parseInt(this.get_method_id))) {
                    this.amount_msz_error = "";
      
                    if (parseInt(this.responseTransLimitDataNew[parseInt(this.get_method_id)].MONTHLY) == 0) {
                        this.raised_max_limit_msg = this.$t("dep_maxlimit");
                        this.disabledProced = true;
                    } else {
                        this.raised_max_limit_msg = "";
                        if (this.responseTransLimitDataNew[parseInt(this.get_method_id)].DAILY < this.responseTransLimitDataNew[parseInt(this.get_method_id)].PERTXN) {
                            this.MinValue = this.responseTransLimitDataNew[parseInt(this.get_method_id)].DAILY;
                        } else {
                            this.MinValue = this.responseTransLimitDataNew[parseInt(this.get_method_id)].PERTXN;
                        }
                        this.disabledProced = false;
                    }
                } else if (parseInt(this.get_method_id) == 1) {
                    if (this.get_user.profile.residence_country != "VN" && this.get_user.profile.residence_country != "ZA" && this.get_user.profile.residence_country != "ID") {
                        if (parseFloat(this.amount) >= this.depositLimitCurrencyWise[this.currency_selected.toUpperCase()]) {
                            this.amount_msz_error = "";
                        }
                    } else if (this.get_user.profile.residence_country == "VN" || this.get_user.profile.residence_country == "ZA" || this.get_user.profile.residence_country == "ID") {
                        if (parseFloat(this.amount) >= this.limit) {
                            this.amount_msz_error = "";
                        }
                    }
                }
            },
            amount: function (val) {
                if (this.checkSuccessDeposit()) {
                    // console.log("000")
                    if (parseInt(this.get_method_id) == 1 && this.get_user.profile.residence_country != "VN" && this.get_user.profile.residence_country != "ZA" && this.get_user.profile.residence_country != "ID") {
                        // console.log("111")
                        if (parseFloat(this.amount) >= this.depositLimitCurrencyWise[this.currency_selected.toUpperCase()]) {
                            this.amount_msz_error = "";
                        } else if (parseInt(this.amount) == 0 || parseFloat(this.amount) < this.depositLimitCurrencyWise[this.currency_selected.toUpperCase()]) {
                            // console.log("333")
                            this.amount_msz_error = this.$t("dep_acc_fund_MinDepAmt") + ":" + this.depositLimitCurrencyWise[this.currency_selected.toUpperCase()] + " " + this.currency_selected;
                        }else{ this.amount_msz_error = ''; }
                    } else if (parseInt(this.get_method_id) == 1 && (this.get_user.profile.residence_country == "VN" || this.get_user.profile.residence_country == "ZA" || this.get_user.profile.residence_country == "ID")) {
                        if (this.currency_selected.toUpperCase() == "ZAR") {
                            this.limit = 80;
                        } else { this.limit = 50; }
                        if (parseFloat(this.amount) >= this.limit) {
                            this.amount_msz_error = "";
                        } else if (parseInt(this.amount) == 0 || parseFloat(this.amount) < this.limit) {
                            if (this.currency_selected.toUpperCase() == "ZAR") {
                                this.amount_msz_error = this.$t("dep_acc_fund_MinDepAmt") + ":" + 80 + " " + this.currency_selected;
                            } else {
                                this.amount_msz_error = this.$t("dep_acc_fund_MinDepAmt") + ":" + 50 + " " + this.currency_selected;
                            }
                        }else{ this.amount_msz_error = ''; }
                    } else if ((parseInt(this.get_method_id) == 18 || parseInt(this.get_method_id) == 3) && parseFloat(this.amount) >= this.limit) {
                        this.amount_msz_error = "";
                    } else if ([27].includes(parseInt(this.get_method_id)) && parseFloat(this.amount) >= parseFloat(this.depositMinAllowedValue[parseInt(this.get_method_id)].min_amount)) {
                        this.amount_msz_error = "";
                        // console.log("444")
                    }else{ this.amount_msz_error = ''; }
                } else if (![24, 27].includes(parseInt(this.get_method_id))) {
      
                    if (this.currency_selected.toUpperCase() == "ZAR") {
                        if (parseInt(this.amount) == 0 || parseFloat(this.amount) < 800) {
                            // console.log("666")
                            this.amount_msz_error = this.amount_msz_error = this.$t("dep_acc_fund_MinDepAmt") + ":" + 800 + " " + this.currency_selected;
                        }else{ this.amount_msz_error = ''; }
                    } else {
                        if (parseInt(this.amount) == 0 || parseFloat(this.amount) < 50) {
                            // console.log("777")
                            this.amount_msz_error = this.amount_msz_error = this.$t("dep_acc_fund_MinDepAmt") + ":" + 50 + " " + this.currency_selected;
                        }else{ this.amount_msz_error = ''; }
                    }
                }else{
                    // console.log("888")
                    this.amount_msz_error = ""
                }
            },
        },
        mounted() {
        },
        methods: {
            handleChangeAmount(e) {
                let value = e.target.value.trim();
                if (!value) {
                    console.warn("Amount cannot be empty");
                    return;
                }
                // console.log(value, "amount field");
            },
            handleChange() {
                if (this.addVertupayBank) {
                    const [bank_code, pay_method] = this.addVertupayBank.split("||");
                    this.get_payment_obj = {
                        bank_code,
                        pay_method 
                    };
                    const eligibleCountries = ['MY', 'TH', 'VN'];
                    if (eligibleCountries.includes(this.get_user.profile.residence_country) && this.get_payment_obj.pay_method == "QR") {
                        this.showAccountName = true; 
                    } else {
                        this.showAccountName = false;
                        this.accountName = ''; 
                    }
                }
            },
            clearOtpInput() {
                $('#exampleModalCenter').modal('hide');  // Hide modal programmatically
                $('.modal-backdrop').remove();
                // console.log(this.$refs.otpInput);
                this.$refs.otpInput.otp = []
                this.otp = ''; // reset the v-model value too
                this.msg = '';
            },
            handleOnComplete(value) {
                this.otp = value;
            },
            handleOnChange(value) {
                // console.log('OTP changed: ', value);
                // console.log('OTP value from data property: ', this.otp);
            },
            // This is your email verification method
            verify_registered_email() {
                let input_json = {
                    globalParams: {
                        otp: this.otp,
                    },
                    localParams: {
                        parameter: this,  // Pass the entire component instance
                        closeModal: this.closeModal  // Pass the closeModal function reference
                    }
                };
                this._runRegisterEmailVerify(input_json);
            },
            // This is your email resend link method
            resend_email() {
                let input_json = {
                    'globalParams': {},
                    'localParams': { "parameter": this }
                };
                this._runRegisterSendEmailOtp(input_json);
                // Show toaster for resend message
                this.$toasted.show("OTP resend request is processing", {
                    position: "top-right",
                    duration: 3000,
                    type: 'info'
                });
            },
            closeModal() {
                $('#exampleModalCenterotp').modal('hide');
                $('.modal-backdrop').remove();
            },
            getCryptoAddress(val) {
                this.apiCryptoAddress = "";
                // let list = this.PaymentMethodList.data.data;
                let list = this.withdrawalMethodResponse[18];
                
                
                let sorted = list.find((res) => res.last_digit_card == val);
                if (sorted) {
                    
                    this.apiCryptoAddress = sorted.online_payment_id;
                } else {
                    this.apiCryptoAddress = "";
                    // this.select_option_method('18')
                }
                return this.apiCryptoAddress;
            },
            ...mapActions({
                _runGetUserIp: types.RUN_GET_USER_IP,
            }),
            copy(data) {
                try {
                    navigator.clipboard.writeText(data);
                    this.copyMsg = "Copied";
                    setTimeout(() => {
                        this.copyMsg = "";
                    }, 3000);
                } catch (e) {
                    this.copyMsg = "Unable to copy";
                    setTimeout(() => {
                        this.copyMsg = "";
                    }, 3000);
                }
            },
            amount_help2pay() {
                this.conversion_unit = (this.convertedCurrencies[this.currency_selected] || {})[this.addhelp2payCurr] || 1;
                this.MinValue = parseFloat(this.amountLimit[this.addhelp2payCurr].maxlength / this.conversion_unit).toFixed(2);
            },
            amount_vertupay() {
                this.conversion_unit = (this.convertedCurrencies[this.currency_selected] || {})[this.addVertupayCurr] || 1;
                this.MinValue = parseFloat(this.vtpAmountLimit[this.addVertupayCurr].maxlength / this.conversion_unit).toFixed(2);
            },
            isSACountry() {
                if (this.get_user.profile && this.get_user.profile.residence_country) {
                    if (this.SACountries.includes(this.get_user.profile.residence_country)) {
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            },
            handleCryptoList(list) {
                let out = list;
                if(!['BTC', 'TRXUSDT', 'TRXUSDC'].includes(list)) {
                    out += '(ERC20)';
                } else if (['TRXUSDT'].includes(list)) {
                    out = 'USDT(TRC20)';
                } else {
                    out = list;
                }
                // commented this curreny as per the requirement mentioned under the FD-1305 
                // else if (['TRXUSDC'].includes(list)) {
                //     out = 'USDC(TRC20)';
                // } 
                return out;
            },
            checkSuccessDeposit() {
                if (this.depositList.totalRecords) {
                    let data = this.depositList.records.filter((val) => parseInt(val.payment_status) == 1);
                    if (data.length > 0) {
                        return true;
                    } else {
                        return false;
                    }
                }
            },
            checkPaymentOptionEligibility(option, imageCheck, pay_code) {
                let countries = this.$env_var.paymentOptionsForCountry['"' + this.get_user.profile.residence_country.toString() + '"'];
                if (countries) {
                    if (imageCheck) {
                        // if (option == 5) {
                        //     let key1 = '"Ecommpay MC"';
                        //     let key2 = '"Ecommpay Visa"';
                        //     if (countries[key1] && countries[key2]) return "CreditCard.svg";
                        //     if (countries[key1]) return "mastercard.svg";
                        //     if (countries[key2]) return "visa.svg";
                        // } 
                        if (option == 32) {
                            let key1 = '"Nuvei MC"';
                            let key2 = '"Nuvei Visa"';
                            if (countries[key1] && countries[key2]) return "CreditCard.svg";
                            if (countries[key1]) return "mastercard.svg";
                            if (countries[key2]) return "visa.png";
                        } else {
                            return this.$env_var.withdrawalMethod[`${option}`];
                        }
                    } else {
                        if (option == "2") {
                            let key = '"Skrill"';
                            return countries[key];
                        } else if (option == "1") {
                            let key = '"Banking (Kopayments)"';
                            return countries[key];
                        } else if (option == "3") {
                            let key = '"Neteller"';
                            return countries[key];
                        } else if (option == "18") {
                            let key = '"Cryptos"';
                            return countries[key];
                        } else if (option == "24") {
                            let key = '"Help2Pay"';
                            return countries[key] /* && [12832,12829,1173].includes(this.get_user.profile.user_id)*/;
                        } else if (option == "26") {
                            let key = '"Payguru"';
                            return countries[key];
                        } else if (option == "27") {
                            let key = '"AstroPay"';
                            return countries[key];
                        } 
                        // else if (option == "31") {
                        //     let key = '"PerfectMoney"';
                        //     return countries[key] /* true   && [12832, 12829, 1173, 95].includes(this.get_user.profile.user_id)*/;
                        // } 
                        else if (option == "32") {
                            let key1 = '"Nuvei MC"';
                            let key2 = '"Nuvei Visa"';
                            if (countries[key1] || countries[key2]) {
                                //return (countries[key1] || countries[key2]) && [12832, 12829, 1173, 4884].includes(this.get_user.profile.user_id); //true;
                                // return (countries[key1] || countries[key2]) && [12832, 12829, 1173].includes(this.get_user.profile.user_id);
                                return true;
                            } else {
                                return false;
                            }
                        } else if (option == "33") {
                            let key = '"TrustPay"';
                            return countries[key] && [12832, 12829, 1173].includes(this.get_user.profile.user_id);
                        } 
                        // else if (option == "5") {
                        //     let key1 = '"Ecommpay MC"';
                        //     let key2 = '"Ecommpay Visa"';
                        //     if (countries[key1] || countries[key2]) {
                        //         return true;
                        //     } else {
                        //         return false;
                        //     }
                        // } 
                        else if (option == "17") {
                            let key1 = '"Gatech"';
                            // let key2 = '"Payguru"';
                            let key3 = '"Payguru EFTs"';
                            let key4 = '"Payguru Mpesa"';
                            let key5 = '"PayRetailers"';
                            if (
                                countries[key1] ||
                                // countries[key2] ||
                                countries[key3] ||
                                countries[key4] ||
                                countries[key5]
                            ) {
                                return true;
                            } else {
                                return false;
                            }
                        } else if (option == "37") {
                            let key = '"Korapay Card"';
                            if (countries[key]) {
                                return true;
                            } else {
                                return false;
                            }
                        } else if (option == "38") {
                            let key = '"Korapay Bank Transfer"';
                            if (countries[key]) {
                                return true;
                            } else {
                                return false;
                            }
                        } else if (option == "39") {
                            let key = '"Korapay Mobile Money"';
                            if (countries[key]) {
                                return true;
                            } else {
                                return false;
                            }
                        } else if (option == "40") {
                            let key = '"Vertupay"';
                            if (countries[key]) {
                                return countries[key] && [32361, 66944, 74030].includes(this.get_user.profile.user_id);
                                // return true;
                            } else {
                                return false;
                            }
                        } else if (option == "41") {
                            let key = '"Payment Asia"';
                            return countries[key] && [32361, 66944, 74030].includes(this.get_user.profile.user_id);
                            // return true;
                        } 
                    }
                    } else if (option == "1") {
                        if (imageCheck) {
                            return this.$env_var.withdrawalMethod[`${option}`];
                        } else {
                            let key = '"Banking (Kopayments)"';
                            return countries ? countries[key] : true;
                        }
                    } else if (option == "18") {
                        if (imageCheck) {
                            return this.$env_var.withdrawalMethod[`${option}`];
                        } else {
                            let key = '"Cryptos"';
                            return countries ? countries[key] : true;
                        }
                    } else {
                        if (imageCheck) {
                            // if (option == 5) {
                            //     return "CreditCard.svg";
                            // }  
                            if (option == 32) {
                                return "CreditCard.svg";
                            } else {
                                return this.$env_var.withdrawalMethod[`${option}`];
                            }
                        } else {
                            return false;
                        }
                    }
            },
            backQr() {
                this.shwStep = 2;
                this.get_method_id = "";
                this.bitcoinConversionData = {};
                this.korapayConvertedData = {};
                this.amount = "";
                this.depositCurrency = "";
                this.apiCryptoAddress = "";
                this.CryptoAddress = "";
                this.ShowAddress = false;
                this.clickMe = false;
                this.pay_option = "";
                // this.astro_cpf_no = "";
            },
            IncreaseLimitOtp() {
                let jsonData = {
                    globalParams: {
                        reason: 193,
                        reason_text: "Increase Crypto Limit",
                        subject: "Increase crypto deposit limit",
                        text: "kindly increase my crypto deposit limit",
                        /*"title": 0,
                    "title_text": "Increase Crypto Limit"*/
                    },
                    localParams: {
                        parameter: this,
                        type: "increase-limit",
                    },
                };
                this._runTicketRequestOtp(jsonData);
            },
            onCopy(e) {
                var _that = this;
                _that.copyText = e.text;
                if (_that.copyText) {
                    _that.showcopymsz = "Copied";
                }
                setTimeout(function () {
                    _that.showcopymsz = "";
                    _that.copyText = "";
                }, 5000);
            },
            onError(e) {
                var _that = this;
                try {
                    _that.showcopymsz = "Unable to Copy";
                    setTimeout(function () {
                        _that.showcopymsz = "";
                        _that.copyText = "";
                    }, 5000);
                } catch (e) {}
            },
            copytoclipboard(textToCopy) {
                var copyText = textToCopy;

                /* Copy the text inside the text field */
                navigator.clipboard.writeText(copyText);
            },
            getUrlForPraxis() {
                let input_json = {
                    globalParams: {
                        currency: this.currency_selected,
                        amount: this.OnlyUsers ? 5 : this.amount,
                        account_id: this.account_id,
                        ip_country: this.userCountry,
                    },
                    localParams: {
                        parameter: this,
                    },
                };
                this._runPraxisUrl(input_json);
            },
            transactionLimitCurrency() {
                let input_json = {
                    globalParams: {
                        currency: this.currency_selected,
                    },
                    localParams: {
                        parameter: this,
                    },
                };
                this._runTransactionLimitCurrency(input_json);
            },
            detailDiv(index) {
                if (this.showIndex == index) {
                    this.showIndex = "-1";
                } else {
                    this.showIndex = index;
                }
            },
            detailDiv1(index) {
                if (this.showIndex1 == index) {
                    this.showIndex1 = "1";
                } else {
                    this.showIndex1 = index;
                }
            },
            select_option_method(getData) {
                this.get_method_id = getData;
                this.amount = "";
                if (parseInt(getData) == 18) {
                    this.depositCurrency = "";
                    this.apiCryptoAddress = "";
                    this.CryptoAddress = "";
                    this.selectcurrency = "";
                    this.addcrptoCurr = "";
                    this.ShowAddress = false;
                    this.clickMe = false;
                    this.changeCrypto("BTC");
                } else if (getData == "24") {
                    this.addhelp2payCurr = this.countryCurrency[this.get_user.profile.residence_country.toString()];
                    this.amount_help2pay();
                } else if (getData == "40") {
                    this.addVertupayCurr = this.vtpCountryCurrency[this.get_user.profile.residence_country.toString()];
                    this.amount_vertupay();
                } else if (getData == "27") {
                    this.astro_cpf_no = "";
                } else if ([37, 38, 39].includes(parseInt(getData))) {
                    this.getKorapayCurrency();
                }
            },
            getKorapayCurrency() {
                if (!Object.keys(this.korapayCurrencyList).length) {
                    let input_json = {
                        globalParams: {
                        },
                        localParams: {
                            parameter: this,
                        },
                    };
                    this._runKorapayCurrency(input_json);
                }
            },
            handleKorapayConversion() {
                let conversion_json = {
                    globalParams: {
                        amount: this.OnlyUsers ? 5 : this.amount,
                        from: this.currency_selected,
                        to: this.korapayCurrency,
                        method_id: parseInt(this.get_method_id),
                        // to: 'BTC',
                    },
                    localParams: {
                        parameter: this,
                        from: 'korapay'
                    },
                };
                this._runBitcoinConversion(conversion_json);
            },
            handleKorapayDeposit() {
                let input_json = {
                    globalParams: {
                        amount: this.korapayConvertedData.converted_amount,
                        currency: this.currency_selected,
                        deposit_currency: this.korapayCurrency,
                        account_id: this.account_id,
                        method_id: this.get_method_id,
                        payment_channel: this.pay_option
                    },
                    localParams: {
                        parameter: this,
                    },
                };
                this._runKorapayDeposit(input_json);
            },
            creditCardDepositFunc() {
                let input_json = {
                    globalParams: {
                        amount: this.OnlyUsers ? 5 : this.amount,
                        currency: this.currency_selected,
                        account_id: this.account_id,
                        ip_country: this.userCountry,
                    },
                    localParams: {
                        parameter: this,
                    },
                };
                this._runCreditCardDeposit(input_json);
            },
            creditNuveiDepositFunc() {
                let input_json = {
                    globalParams: {
                        amount: this.OnlyUsers ? 5 : this.amount,
                        currency: this.currency_selected,
                        account_id: this.account_id,
                        method_id: this.get_method_id,
                    },
                    localParams: {
                        parameter: this,
                    },
                };
                this._runGetNuveiDetail(input_json);
            },
            AddCryptoAddress() {
                const _that = this;
                this.submitted = true;
                this.$validator.validate().then((valid) => {
                    if (valid) {
                        if (_that.depositCurrency != "") {
                            if (_that.apiCryptoAddress != "") {
                                _that.cryptoConvirsion();
                            } else {
                                let conversion_json = {
                                    globalParams: {
                                        address: _that.CryptoAddress,
                                        payment_method: _that.cryptoMethods[_that.depositCurrency],
                                        currency: "BTC",
                                    },
                                    localParams: {
                                        parameter: _that,
                                    },
                                };
                                conversion_json.globalParams.currency = _that.addcrptoCurr;
                                // if(parseInt(this.get_user.profile.user_id) == 641 || parseInt(this.get_user.profile.user_id) == 510 || parseInt(this.get_user.profile.user_id) == 10141){
                                // }
                                _that._runAddCryptoMethod(conversion_json);
                            }
                        }
                    }
                });
            },
            cryptoConvirsion() {
                let conversion_json = {
                    globalParams: {
                        amount: this.OnlyUsers ? 5 : this.amount, // added conditon for testing purpse only, will remove after trested by harpreet sir
                        from: this.currency_selected,
                        to: "BTC",
                    },
                    localParams: {
                        parameter: this,
                    },
                };
                if(this.selectcurrency.includes("(TRC20)")){
                    this.selectcurrency = this.selectcurrency.replace('(TRC20)','')
                }
                conversion_json.globalParams.to = this.selectcurrency;
                if (this.addcrptoCurr != "") {
                    conversion_json.globalParams.to = this.addcrptoCurr;
                    this.selectcurrency = this.addcrptoCurr;
                }
                this._runBitcoinConversion(conversion_json);
            },
            changeCrypto(key) {
                if (this.depositCurrency != key) {
                    this.depositCurrency = key;
                    this.apiCryptoAddress = "";
                    this.CryptoAddress = "";
                    this.clickMe = false;
                    let input_json = {
                        globalParams: {
                            payment_method: this.cryptoMethods[this.depositCurrency],
                        },
                        localParams: {
                            parameter: this,
                        },
                    };
                    this._runGetCryptoMethod(input_json);
                }
            },
            cryptDepositFunc() {
                this.cryptoDepositAddress = "";
                let input_json = {
                    globalParams: {
                        account_id: this.account_id,
                        amount: this.bitcoinConversionData.converted_amount,
                        currency: this.selectcurrency,
                        ip_country: this.userCountry,
                    },
                    localParams: {
                        parameter: this,
                    },
                };
                this._runCryptoDeposit(input_json);
            },
            getTransactionId() {
                let input_json = {
                    globalParams: {
                        amount: this.OnlyUsers ? 5 : this.amount,
                        currency: this.currency_selected,
                        account_id: this.account_id,
                        method_id: this.get_method_id,
                        ip_country: this.userCountry,
                    },
                    localParams: {
                        parameter: this,
                    },
                };
                if (parseInt(this.get_method_id) == 3) {
                    input_json.globalParams["payment_method_email"] = this.withdrawalMethodResponse[this.get_method_id] ? this.withdrawalMethodResponse[this.get_method_id][0].online_payment_id : "";
                }
                this._runCreditCardDeposit(input_json);
            },
            validateValue() {
                const _that = this;
                this.submitted = true;
                this.$validator.validate().then((valid) => {
                    if (valid) {
          
                        if (this.checkSuccessDeposit()) {
                            if (parseInt(this.get_method_id) == 1) {
                                if (parseInt(this.amount) == 0 || parseFloat(this.amount) < this.depositLimitCurrencyWise[this.currency_selected.toUpperCase()]) {
                                    this.amount_msz_error = this.$t("dep_acc_fund_MinDepAmt") + ":" + this.depositLimitCurrencyWise[this.currency_selected.toUpperCase()] + " " + this.currency_selected;
                                } else {
                                    this.amount_msz_error = "";
                                    this.shwStep = 3;
                                    this.bankDeposit();
                                }
                            } else if ([5, 3, 2, 17, 18, 24, 25, 26, 27, 31, 32, 33, 37, 38, 39, 40, 41].includes(parseInt(this.get_method_id))) {
                               
                  
                                this.amount_msz_error = "";
                                if (parseFloat(this.amount) <= parseFloat(this.MinValue)) {
                                    // console.log("BBB")
                                    this.amount_msz_error = "";
                                    if (this.currency_selected.toUpperCase() == "ZAR") {
                                        if (this.checkSuccessDeposit()) {
                                            _that.depositMinAllowedValue[parseInt(_that.get_method_id)].min_amount = 80;
                                        } else {
                                            _that.depositMinAllowedValue[parseInt(_that.get_method_id)].min_amount = 800;
                                        }
                                    } else {
                                        _that.depositMinAllowedValue = {
                                            1: { min_amount: 500 },
                                            2: { min_amount: 50 },
                                            3: { min_amount: 50 },
                                            5: { min_amount: 50 },
                                            6: { min_amount: 50 },
                                            7: { min_amount: 50 },
                                            8: { min_amount: 50 },
                                            9: { min_amount: 50 },
                                            10: { min_amount: 50 },
                                            17: { min_amount: 50 },
                                            18: { min_amount: 50 },
                                            24: { min_amount: 50 },
                                            25: { min_amount: 50 },
                                            26: { min_amount: 50 },
                                            27: { min_amount: 50 },
                                            31: { min_amount: 50 },
                                            32: { min_amount: 50 },
                                            33: { min_amount: 50 },
                                            37: { min_amount: 50 },
                                            38: { min_amount: 50 },
                                            39: { min_amount: 50 },
                                            40: { min_amount: 50 },
                                            41: { min_amount: 50 },
                                        };
                                        if (_that.get_method_id == 24) {
                                            _that.depositMinAllowedValue[24].min_amount = Math.ceil(((this.amountLimit[this.addhelp2payCurr] || {}).minlength || 1) / this.conversion_unit);
                                        } 
                                        // else if (_that.get_method_id == 40) {
                                        //     _that.depositMinAllowedValue[40].min_amount = Math.ceil(((this.vtpAmountLimit[this.addVertupayCurr] || {}).minlength || 1) / this.conversion_unit);
                                        // }
                                    }
                                    if (parseFloat(this.amount) < parseFloat(_that.depositMinAllowedValue[parseInt(_that.get_method_id)].min_amount) && ![24].includes(parseInt(this.get_method_id))) {
                                        // console.log("ABABAB")
                                        this.amount_msz_error = this.$t("dep_acc_fund_MinDepAmt") + ":" + _that.depositMinAllowedValue[parseInt(_that.get_method_id)].min_amount + " " + this.currency_selected;
                                    } else if (parseFloat(this.amount) == 0 && ![24].includes(parseInt(this.get_method_id))) {
                                        // console.log("CDCDCD")
                                        this.amount_msz_error = this.$t("dep_acc_fund_MinDepAmt") + ":" + _that.depositMinAllowedValue[parseInt(_that.get_method_id)].min_amount + " " + this.currency_selected;
                                    } else {
                                        // console.log("EFEFEF")
                                        this.amount_msz_error = "";
                                        if (parseInt(this.get_method_id) == 5) {
                                            this.shwStep = 5;
                                        } else if (parseInt(this.get_method_id) == 3) {
                                            this.shwStep = 6;
                                        } else if (parseInt(this.get_method_id) == 2) {
                                            this.shwStep = 7;
                                        } else if (parseInt(this.get_method_id) == 17) {
                                            this.shwStep = 8;
                                        } else if (parseInt(this.get_method_id) == 18) {
                                            this.amount_msz_error = "";
                                            this.AddCryptoAddress();
                                        } else if (parseInt(this.get_method_id) == 25) {
                                            let input_json = {
                                                globalParams: {
                                                    amount: this.OnlyUsers ? 5 : this.amount,
                                                    currency: this.currency_selected,
                                                    account_id: this.account_id,
                                                    method_id: this.get_method_id,
                                                },
                                                localParams: {
                                                    parameter: this,
                                                },
                                            };
                                            this._runGetSwiffyDetail(input_json);
                                        } else if (parseInt(this.get_method_id) == 24) {
                                            let input_json = {
                                                globalParams: {
                                                    amount: this.OnlyUsers ? 5 : this.amount,
                                                    currency: this.currency_selected,
                                                    account_id: this.account_id,
                                                    method_id: this.get_method_id,
                                                    to_currency: this.addhelp2payCurr,
                                                    bank: this.addhelp2payBank,
                                                },
                                                localParams: {
                                                    parameter: this,
                                                },
                                            };
                                            this._runGetHelp2PayDetail(input_json);
                                        } else if (parseInt(this.get_method_id) == 26) {
                                            let input_json = {
                                                globalParams: {
                                                    amount: this.OnlyUsers ? 5 : this.amount,
                                                    currency: this.currency_selected,
                                                    account_id: this.account_id,
                                                    method_id: this.get_method_id,
                                                },
                                                localParams: {
                                                    parameter: this,
                                                },
                                            };
                                            this._runGetPayguruDetail(input_json);
                                        } else if (parseInt(this.get_method_id) == 27) {
                                            this.doc_error = '';
                                            let input_json = {
                                                globalParams: {
                                                    amount: this.OnlyUsers ? 5 : this.amount,
                                                    currency: this.currency_selected,
                                                    account_id: this.account_id,
                                                    method_id: this.get_method_id,
                                                    payment_method_code: this.pay_option,
                                                    document: this.astro_cpf_no || this.$store.state.user.profile.astro_cpf_no,
                                                    // phone: this.countrycode + this.phone,
                                                    document_type: this.document_type,
                                                },
                                                localParams: {
                                                    parameter: this,
                                                },
                                            };
                                            this._runGetAstroPayDetail(input_json);
                                        } else if (parseInt(this.get_method_id) == 31) {
                                            let input_json = {
                                                globalParams: {
                                                    payment_amount: this.OnlyUsers ? 5 : this.amount,
                                                    // payment_amount: '0.1',
                                                    currency: this.currency_selected,
                                                    account_id: this.account_id,
                                                    method_id: this.get_method_id,
                                                },
                                                localParams: {
                                                    parameter: this,
                                                },
                                            };
                                            this._runGetPerfectMoneyDetail(input_json);
                                        } else if (parseInt(this.get_method_id) == 32) {
                                            this.shwStep = 32;
                                        } else if (parseInt(this.get_method_id) == 33) {
                                            let input_json = {
                                                globalParams: {
                                                    amount: this.OnlyUsers ? 5 : this.amount,
                                                    currency: this.currency_selected,
                                                    account_id: this.account_id,
                                                    method_id: this.get_method_id,
                                                },
                                                localParams: {
                                                    parameter: this,
                                                },
                                            };
                                            this._runGetTrustPayDetail(input_json);
                                        } else if ([37, 38, 39].includes(parseInt(this.get_method_id))) {
                                            // this.shwStep = 37;
                                            this.handleKorapayConversion();
                                        } else if (parseInt(this.get_method_id) == 40) {
                                            const eligibleCountries = ['MY', 'TH', 'VD'];
                                            let input_json = {
                                                globalParams: {
                                                    currency: this.currency_selected,
                                                    bank_code: this.get_payment_obj.bank_code,
                                                    payment_channel: this.get_payment_obj.pay_method,
                                                    amount: this.OnlyUsers ? 5 : this.amount,
                                                    account_id: this.account_id,
                                                    method_id: this.get_method_id,
                                                    to_currency: this.addVertupayCurr,
                                                },
                                                localParams: {
                                                    parameter: this,
                                                },
                                            };
                                            if (eligibleCountries.includes(this.get_user.profile.residence_country) && this.get_payment_obj.pay_method == "QR") {
                                                input_json.globalParams.account_name = this.accountName;
                                            }
                                            this._runGetVertuPayDetail(input_json);
                                        } else if (parseInt(this.get_method_id) == 41) {
                                            let input_json = {
                                                globalParams: {
                                                    amount: this.OnlyUsers ? 5 : this.amount,
                                                    currency: this.currency_selected,
                                                    account_id: this.account_id,
                                                    to_currency: "IDR",
                                                    method_id: this.get_method_id,
                                                },
                                                localParams: {
                                                    parameter: this,
                                                },
                                            };
                                            this._runGetPaymentAsiaDetail(input_json);
                                        } 
                                    }
                                } else {
                                    // console.log("TAG 111")
                                    this.amount_msz_error = this.$t("dep_maxdeposit") + this.MinValue + " " + this.currency_selected;
                                }
                            } else if (parseInt(this.get_method_id) == 23) {
                                this.paysafeCheckout();
                            }
                        } else {
                            if (this.currency_selected.toUpperCase() == "ZAR") {
                                if (parseInt(this.get_method_id) == 1) {
                                    if (parseInt(this.amount) == 0 || parseFloat(this.amount) < 800) {
                                        this.amount_msz_error = this.$t("dep_acc_fund_MinDepAmt") + ":" + 800 + " " + this.currency_selected;
                                    } else {
                                        this.amount_msz_error = "";
                                        this.shwStep = 3;
                                        this.bankDeposit();
                                    }
                                } else if ([5, 3, 2, 17, 18, 24, 25, 26, 27, 31, 32, 33, 37, 38, 39, 40, 41].includes(parseInt(this.get_method_id))) {
                                    if (parseFloat(this.amount) <= parseFloat(this.MinValue)) {
                                        this.amount_msz_error = "";
                                        if (parseInt(this.amount) < 800 && ![24].includes(parseInt(this.get_method_id))) {
                                            this.amount_msz_error = this.$t("dep_acc_fund_MinDepAmt") + ":" + 800 + " " + this.currency_selected;
                                        } else if (parseInt(this.amount) == 0 && ![24].includes(parseInt(this.get_method_id))) {
                                            this.amount_msz_error = this.$t("dep_acc_fund_MinDepAmt") + ":" + 800 + " " + this.currency_selected;
                                        } else {
                                            this.amount_msz_error = "";
                                            if (parseInt(this.get_method_id) == 5) {
                                                this.shwStep = 5;
                                            } else if (parseInt(this.get_method_id) == 3) {
                                                this.shwStep = 6;
                                            } else if (parseInt(this.get_method_id) == 2) {
                                                this.shwStep = 7;
                                            } else if (parseInt(this.get_method_id) == 17) {
                                                this.shwStep = 8;
                                            } else if (parseInt(this.get_method_id) == 18) {
                                                this.amount_msz_error = "";
                                                this.AddCryptoAddress();
                                            } else if (parseInt(this.get_method_id) == 25) {
                                                let input_json = {
                                                    globalParams: {
                                                        amount: this.OnlyUsers ? 5 : this.amount,
                                                        currency: this.currency_selected,
                                                        account_id: this.account_id,
                                                        method_id: this.get_method_id,
                                                    },
                                                    localParams: {
                                                        parameter: this,
                                                    },
                                                };
                                                this._runGetSwiffyDetail(input_json);
                                            } else if (parseInt(this.get_method_id) == 24) {
                                                let input_json = {
                                                    globalParams: {
                                                        amount: this.OnlyUsers ? 5 : this.amount,
                                                        currency: this.currency_selected,
                                                        account_id: this.account_id,
                                                        method_id: this.get_method_id,
                                                        to_currency: this.addhelp2payCurr,
                                                        bank: this.addhelp2payBank,
                                                    },
                                                    localParams: {
                                                        parameter: this,
                                                    },
                                                };
                                                this._runGetHelp2PayDetail(input_json);
                                            } else if (parseInt(this.get_method_id) == 26) {
                                                let input_json = {
                                                    globalParams: {
                                                        amount: this.OnlyUsers ? 5 : this.amount,
                                                        currency: this.currency_selected,
                                                        account_id: this.account_id,
                                                        method_id: this.get_method_id,
                                                    },
                                                    localParams: {
                                                        parameter: this,
                                                    },
                                                };
                                                this._runGetPayguruDetail(input_json);
                                            } else if (parseInt(this.get_method_id) == 27) {
                                                this.doc_error = '';
                                                let input_json = {
                                                    globalParams: {
                                                        amount: this.OnlyUsers ? 5 : this.amount,
                                                        currency: this.currency_selected,
                                                        account_id: this.account_id,
                                                        method_id: this.get_method_id,
                                                        payment_method_code: this.pay_option,
                                                        document: this.astro_cpf_no || this.$store.state.user.profile.astro_cpf_no,
                                                        // phone: this.countrycode + this.phone,
                                                        document_type: this.document_type,
                                                    },
                                                    localParams: {
                                                        parameter: this,
                                                    },
                                                };
                                                this._runGetAstroPayDetail(input_json);
                                            } else if (parseInt(this.get_method_id) == 31) {
                                                let input_json = {
                                                    globalParams: {
                                                        payment_amount: this.OnlyUsers ? 5 : this.amount,
                                                        // payment_amount: '0.1',
                                                        currency: this.currency_selected,
                                                        account_id: this.account_id,
                                                        method_id: this.get_method_id,
                                                    },
                                                    localParams: {
                                                        parameter: this,
                                                    },
                                                };
                                                this._runGetPerfectMoneyDetail(input_json);
                                            } else if (parseInt(this.get_method_id) == 32) {
                                                this.shwStep = 32;
                                            } else if (parseInt(this.get_method_id) == 33) {
                                                let input_json = {
                                                    globalParams: {
                                                        amount: this.OnlyUsers ? 5 : this.amount,
                                                        currency: this.currency_selected,
                                                        account_id: this.account_id,
                                                        method_id: this.get_method_id,
                                                    },
                                                    localParams: {
                                                        parameter: this,
                                                    },
                                                };
                                                this._runGetTrustPayDetail(input_json);
                                            } else if ([37, 38, 39].includes(parseInt(this.get_method_id))) {
                                                // this.shwStep = 37;
                                                this.handleKorapayConversion();
                                            } else if (parseInt(this.get_method_id) == 40) {
                                                const eligibleCountries = ['MY', 'TH', 'VD'];
                                                let input_json = {
                                                    globalParams: {
                                                        currency: this.currency_selected,
                                                        bank_code: this.get_payment_obj.bank_code,
                                                        payment_channel: this.get_payment_obj.pay_method,
                                                        amount: this.OnlyUsers ? 5 : this.amount,
                                                        account_id: this.account_id,
                                                        method_id: this.get_method_id,
                                                        to_currency: this.addVertupayCurr,
                                                    },
                                                    localParams: {
                                                        parameter: this,
                                                    },
                                                };
                                                if (eligibleCountries.includes(this.get_user.profile.residence_country) && this.get_payment_obj.pay_method == "QR") {
                                                    input_json.globalParams.account_name = this.accountName;
                                                }
                                                this._runGetVertuPayDetail(input_json);
                                            } else if (parseInt(this.get_method_id) == 41) {
                                                let input_json = {
                                                    globalParams: {
                                                        amount: this.OnlyUsers ? 5 : this.amount,
                                                        currency: this.currency_selected,
                                                        account_id: this.account_id,
                                                        to_currency: "IDR",
                                                        method_id: this.get_method_id,
                                                    },
                                                    localParams: {
                                                        parameter: this,
                                                    },
                                                };
                                                this._runGetPaymentAsiaDetail(input_json);
                                            } 
                                        }
                                    } else {
                                        this.amount_msz_error = this.$t("dep_maxdeposit") + this.MinValue + " " + this.currency_selected;
                                    }
                                } else if (parseInt(this.get_method_id) == 23) {
                                    this.paysafeCheckout();
                                }
                            } else {
                                if (parseInt(this.get_method_id) == 1) {
                                    if (parseInt(this.amount) == 0 || parseFloat(this.amount) < 50) {
                                        this.amount_msz_error = this.$t("dep_acc_fund_MinDepAmt") + ":" + 50 + " " + this.currency_selected;
                                    } else {
                                        this.amount_msz_error = "";
                                        this.shwStep = 3;
                                        this.bankDeposit();
                                    }
                                }
                                else if ([5, 3, 2, 17, 18, 24, 25, 26, 27, 31, 32, 33, 37, 38, 39, 40, 41].includes(parseInt(this.get_method_id))) {
                      
                                    if (parseFloat(this.amount) <= parseFloat(this.MinValue)) {
                                        this.amount_msz_error = "";
                                        if (parseInt(this.amount) < 50 && ![24, 27].includes(parseInt(this.get_method_id))) {
                                            // console.log("TAG222");
                                            this.amount_msz_error = this.$t("dep_acc_fund_MinDepAmt") + ":" + 50 + " " + this.currency_selected;
                                        } else if (parseInt(this.amount) == 0 && ![24, 27].includes(parseInt(this.get_method_id))) {
                                            // console.log("TAG333");
                                            this.amount_msz_error = this.$t("dep_acc_fund_MinDepAmt") + ":" + 50 + " " + this.currency_selected;
                                        } else if ([27].includes(parseInt(this.get_method_id)) && parseInt(this.amount) < this.depositMinAllowedValue[27].min_amount) {
                                            // console.log("TAG444");
                                            this.amount_msz_error = this.$t("dep_acc_fund_MinDepAmt") + ":" + this.depositMinAllowedValue[27].min_amount + " " + this.currency_selected;
                                        } else {
                                            // console.log("TAG555");
                                            this.amount_msz_error = "";
                                            if (parseInt(this.get_method_id) == 5) {
                                                this.shwStep = 5;
                                            } else if (parseInt(this.get_method_id) == 3) {
                                                this.shwStep = 6;
                                            } else if (parseInt(this.get_method_id) == 2) {
                                                this.shwStep = 7;
                                            } else if (parseInt(this.get_method_id) == 17) {
                                                this.shwStep = 8;
                                            } else if (parseInt(this.get_method_id) == 18) {
                                                this.amount_msz_error = "";
                                                this.AddCryptoAddress();
                                            } else if (parseInt(this.get_method_id) == 25) {
                                                let input_json = {
                                                    globalParams: {
                                                        amount: this.OnlyUsers ? 5 : this.amount,
                                                        currency: this.currency_selected,
                                                        account_id: this.account_id,
                                                        method_id: this.get_method_id,
                                                    },
                                                    localParams: {
                                                        parameter: this,
                                                    },
                                                };
                                                this._runGetSwiffyDetail(input_json);
                                            } else if (parseInt(this.get_method_id) == 24) {
                                                let input_json = {
                                                    globalParams: {
                                                        amount: this.OnlyUsers ? 5 : this.amount,
                                                        currency: this.currency_selected,
                                                        account_id: this.account_id,
                                                        method_id: this.get_method_id,
                                                        to_currency: this.addhelp2payCurr,
                                                        bank: this.addhelp2payBank,
                                                    },
                                                    localParams: {
                                                        parameter: this,
                                                    },
                                                };
                                                this._runGetHelp2PayDetail(input_json);
                                            } else if (parseInt(this.get_method_id) == 26) {
                                                let input_json = {
                                                    globalParams: {
                                                        amount: this.OnlyUsers ? 5 : this.amount,
                                                        currency: this.currency_selected,
                                                        account_id: this.account_id,
                                                        method_id: this.get_method_id,
                                                    },
                                                    localParams: {
                                                        parameter: this,
                                                    },
                                                };
                                                this._runGetPayguruDetail(input_json);
                                            } else if (parseInt(this.get_method_id) == 27) {
                                                this.doc_error = '';
                                                let input_json = {
                                                    globalParams: {
                                                        amount: this.OnlyUsers ? 5 : this.amount,
                                                        currency: this.currency_selected,
                                                        account_id: this.account_id,
                                                        method_id: this.get_method_id,
                                                        payment_method_code: this.pay_option,
                                                        document: this.astro_cpf_no || this.$store.state.user.profile.astro_cpf_no,
                                                        // phone: this.countrycode + this.phone,
                                                        document_type: this.document_type,
                                                    },
                                                    localParams: {
                                                        parameter: this,
                                                    },
                                                };
                                                this._runGetAstroPayDetail(input_json);
                                            } else if (parseInt(this.get_method_id) == 31) {
                                                let input_json = {
                                                    globalParams: {
                                                        payment_amount: this.OnlyUsers ? 5 : this.amount,
                                                        // payment_amount: '0.1',
                                                        currency: this.currency_selected,
                                                        account_id: this.account_id,
                                                        method_id: this.get_method_id,
                                                    },
                                                    localParams: {
                                                        parameter: this,
                                                    },
                                                };
                                                this._runGetPerfectMoneyDetail(input_json);
                                            } else if (parseInt(this.get_method_id) == 32) {
                                                this.shwStep = 32;
                                            } else if (parseInt(this.get_method_id) == 33) {
                                                let input_json = {
                                                    globalParams: {
                                                        amount: this.OnlyUsers ? 5 : this.amount,
                                                        currency: this.currency_selected,
                                                        account_id: this.account_id,
                                                        method_id: this.get_method_id,
                                                    },
                                                    localParams: {
                                                        parameter: this,
                                                    },
                                                };
                                                this._runGetTrustPayDetail(input_json);
                                            } else if ([37, 38, 39].includes(parseInt(this.get_method_id))) {
                                                // this.shwStep = 37;
                                                this.handleKorapayConversion();
                                            } else if (parseInt(this.get_method_id) == 40) {
                                                const eligibleCountries = ['MY', 'TH', 'VD'];
                                                let input_json = {
                                                    globalParams: {
                                                        currency: this.currency_selected,
                                                        bank_code: this.get_payment_obj.bank_code,
                                                        payment_channel: this.get_payment_obj.pay_method,
                                                        amount: this.OnlyUsers ? 5 : this.amount,
                                                        account_id: this.account_id,
                                                        method_id: this.get_method_id,
                                                        to_currency: this.addVertupayCurr,
                                                    },
                                                    localParams: {
                                                        parameter: this,
                                                    },
                                                };
                                                if (eligibleCountries.includes(this.get_user.profile.residence_country) && this.get_payment_obj.pay_method == "QR") {
                                                    input_json.globalParams.account_name = this.accountName;
                                                }
                                                this._runGetVertuPayDetail(input_json);
                                            } else if (parseInt(this.get_method_id) == 41) {
                                                let input_json = {
                                                    globalParams: {
                                                        amount: this.OnlyUsers ? 5 : this.amount,
                                                        currency: this.currency_selected,
                                                        account_id: this.account_id,
                                                        to_currency: "IDR",
                                                        method_id: this.get_method_id,
                                                    },
                                                    localParams: {
                                                        parameter: this,
                                                    },
                                                };
                                                this._runGetPaymentAsiaDetail(input_json);
                                            } 
                                        }
                                    } else {
                          
                                        this.amount_msz_error = this.$t("dep_maxdeposit") + this.MinValue + " " + this.currency_selected;
                          
                                    }
                                } else if (parseInt(this.get_method_id) == 23) {
                                    this.paysafeCheckout();
                                }
                            }
                        }
                        document.getElementById("form").scrollIntoView({
                            behavior: "smooth",
                        });
                    } else {
                        _that.handleValidationErrorAdvanced(_that.errors);
                    }
                });
            },
            paysafeCheckout() {
                paysafe.checkout.setup(
                    "T1QtODUzMzgwOkItcWEyLTAtNjIxYzgwNmMtMC0zMDJjMDIxNDJkNzM2OGY0NWVjMDczZTc0YmRlMjIwZGUzNTJkZTQ0MDRhY2NkZjQwMjE0MDUzM2JkNDkxZDZjNDgxODE5NzRmYzdkOWFhYTkxZjcwYjdiMmY1NA==",
                    {
                        merchantRefNum: "T1QtODUzMzgwOkItcWEyLTAtNjIxYzgwNmMtMC0zMDJjMDIxNDJkNzM2OGY0NWVjMDczZTc0YmRlMjIwZGUzNTJkZTQ0MDRhY2NkZjQwMjE0MDUzM2JkNDkxZDZjNDgxODE5NzRmYzdkOWFhYTkxZjcwYjdiMmY1NA==",
                        amount: (this.OnlyUsers ? 5 : this.amount) * 100,
                        currency: "EUR",
                        environment: "TEST",
                        holderName: this.get_user.username,
                        companyName: "FXView",
                        billingAddress: {
                            country: this.get_user.profile.residence_country,
                            zip: this.get_user.profile.post_code,
                            city: this.get_user.profile.city,
                            street: this.get_user.profile.address1,
                            street2: this.get_user.profile.address2,
                        },
                    },
                    (instance, error, result) => {
                        if (!error) {
                            if (result.token) {
                                instance.showSuccessScreen();
                                if (result.paymentMethod == "Cards") {
                                    // console.log("result", result);
                                    // console.log("error", error);
                                    // console.log("instance", instance);
                                    // this.paysafeCardCall(result.token);
                                    // use AJAX to send result.token to your merchant server to take CC payment
                                }

                                if (result.paymentMethod == "DirectDebit") {
                                    // use AJAX to send result.token to your merchant server to take DD payment
                                }

                                if (result.paymentMethod == "Interac") {
                                    // use AJAX to send result.token to your merchant server to take Interac payment
                                }

                                if (result.paymentMethod == "PayPal") {
                                    // use AJAX to send result.token to your merchant server to take PayPal payment
                                }
                            } else {
                                // error handling
                            }
                        } else {
                            instance.showFailureScreen();
                        }
                    }
                );
            },
            paysafeCardCall(token) {
                // console.log("asdadasd", token);
                axios
                    .post(
                        "https://api.test.paysafe.com/cardpayments/v1/accounts/1002371220/auths",
                        {
                            merchantRefNum: new Date().getTime(),
                            settleWithAuth: true,
                            amount: (this.OnlyUsers ? 5 : this.amount) * 100,
                            card: {
                                paymentToken: token,
                            },
                        },
                        {
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: "Basic dGVzdF9wcl90ZXN0OkItcWEyLTAtNjIxYzVmZDYtMC0zMDJjMDIxNDBmZjQwZjZkYmEzYTc0ZjAyMjlmZDQ1Yjg5YzJkMjBlMDRiMzJlY2EwMjE0NGMyM2QyNDM3YzFkNTZjNDJmN2MzNTFhZjJhOGM5MzMwMmNmZDk4MA==",
                            },
                        }
                    )
                    .then((response) => {
                        // console.log(response);
                    })
                    .catch((error) => {
                        // console.log(error);
                    });
            },
            bankDeposit() {
                const _that = this;
                let form_name = new FormData();

                let comment =
                    this.$t("dep_pleaseDeposit") +
                    " " +
                    this.currency_selected +
                    " " +
                    this.amount +
                    " " +
                    this.$t("dep_pleaseDeposit1") +
                    this.$t("dep_AccNumber") +
                    " " +
                    this.bankData.account_no +
                    " " +
                    this.$t("dep_holdername") +
                    " " +
                    this.bankData.holder_name +
                    " " +
                    this.$t("dep_bankname") +
                    " " +
                    this.bankData.bank_name +
                    " " +
                    this.$t("dw_bankCode") +
                    " " +
                    this.bankData.bank_code +
                    " " +
                    this.$t("dep_brsortCode") +
                    " " +
                    this.bankData.sort_code +
                    " " +
                    this.$t("dep_brbankAdress") +
                    " " +
                    this.bankData.bank_address;
                    form_name.append("reason", 120);
                    form_name.append("reason_text", "BANK DEPOSIT");
                    form_name.append("title", 0);
                    form_name.append("title_text", "");
                    form_name.append("text", comment);
                    form_name.append("ip_country", this.userCountry);

                _that.$validator.validate().then((valid) => {
                    if (valid) {
                        let input_json = {
                            globalParams: {
                                form: form_name,
                            },
                            localParams: {
                                parameter: _that,
                                module: "ticket-reply",
                            },
                        };
                        _that._runTicketRequestOtp(input_json);
                    }
                });
            },
            bankDepositForFewCountries() {
                const _that = this;
                _that.$validator.validate().then((valid) => {
                    if (valid) {
                        let input_json = {
                            globalParams: {
                                amount: this.OnlyUsers ? 5 : _that.amount,
                                currency: _that.currency_selected,
                                account_id: _that.account_id,
                                country: _that.get_user.profile.residence_country,
                                ip_country: this.userCountry,
                                "payment_method ": _that.payment_method_acc_to_country[_that.get_user.profile.residence_country],
                            },
                            localParams: {
                                parameter: _that,
                            },
                        };
                        _that._runBankDepositForFewCountries(input_json);
                    }
                });
            },
            reset() {
                this.account_id = "";
                this.act_account_id = "";
                this.amount = "";
                this.bankData = {};
                this.pay_option = "";
                this.submitted = false;
                this.get_method_id = "";
                this.document = "";
                this.korapayCurrency = "";
                // this.phone = "";
            },
            submitPay(transaction_id) {
                this.transaction_id = transaction_id;

                setTimeout(function () {
                    document.getElementById("skrillForm").submit();
                }, 3000);
            },
            documentValidation() {
                this.doc_error = '';
            },
            doneAstrorequest() {
                this.qr_image = null; 
                this.copyMsg = ''; 
                this.astropayConvertedAmount = '';
                window.location.reload();
            },
            conversionAmount() {
                if (this.timeout) clearTimeout(this.timeout); 
                this.timeout = setTimeout(() => {
                    const _that = this;
                    if(this.pay_option == 'IX') {
                        let input_json = {
                            globalParams: {
                                amount: this.OnlyUsers ? 5 : _that.amount,
                                currency: _that.currency_selected,
                            },
                            localParams: {
                                parameter: _that,
                            },
                        };
                        _that._runAstropayCurrencyConversion(input_json);
                    }
                }, 500); // delay
            },
        },
        props: ["callFrom"],
        created() {
            if (this.showAccountName) {
                globalParams.account_name = this.accountName;
            }
            if(this.get_user.is_email_verified == 0) {
                this._runRegisterSendEmailOtp({
                    globalParams: {},
                    localParams: {
                        parameter: this,
                    },
                });
            }
            // Function to remove query parameters from the current URL
            function removeQueryParameters() {
                // Get the current URL
                let currentUrl = window.location.href;
                // Check if the URL has any query parameters
                if (currentUrl.includes('?')) {
                    // Remove the query parameters by taking the part of the URL before the '?'
                    // Update the browser URL without reloading the page
                    currentUrl = currentUrl.split('?')[0];
                    window.history.replaceState({}, document.title, currentUrl);

                }
            }
            if (this.$route.path == '/account-funding') {
                removeQueryParameters();
            }
            this._runGetUserIp({
                globalParams: {},
                localParams: {
                    parameter: this,
                },
            });
            if (this.$store.getters[Const.GET_WITHDRAWAL_METHOD_RESPONSE] != "") {
                this.loaderFuncRun = "0";
            }
            const { astro_cpf_no } = this.$store.getters.GET_USER.profile;
            // this.astro_cpf_no = this.$store.getters.GET_USER.profile.user_id === 1173 ? '01234567890' : astro_cpf_no;
            this.astro_cpf_no = astro_cpf_no;
            this._runGetWithdrawalMethods({
                globalParams: {},
                localParams: {
                    parameter: this,
                    loaderFuncRun: this.loaderFuncRun,
                },
            });

            if (this.callFrom != "" && this.callFrom != null && this.callFrom != undefined) {
                this.account_id = this.walletAccount.recamount_hpords[0].account_id;
                this.act_account_id = this.walletAccount.records[0].act_account_id;
                this.currency_selected = this.walletAccount.records[0].currency;
                this.shwStep = 2;
                this.transactionLimitCurrency();
            }
            //===comes from manage-account-page
            if (this.$route.params.account_id) {
                this.account_id = this.$route.params.account_id;
                this.act_account_id = this.$route.params.act_account_id;
                this.currency_selected = this.$route.params.currency;
                this.shwStep = 2;
                this.transactionLimitCurrency();
            }

            //comes from ticket add new bank page
            if (this.$route.params.account_id_from_ticket) {
                this.shwStep = 2;
                this.response_msg = "suceessMsz20";
                this.msg_type = "success";
                this.account_id = this.$route.params.account_id_from_ticket;
            }

            //comes back from credit card deposit page
            let query = Object.assign({}, this.$route.amount_hpquery);
            if (this.$route.query.msg) {
                if (query.msg == "success") {
                    this.response_msg = this.$t("dep_depositDone");
                    this.msg_type = "success";
                } else if (query.msg == "fail") {
                    this.response_msg = this.$t("dep_depositFail");
                    this.msg_type = "error";
                }
                delete query.msg;

                this.$router.replace({
                    query,
                });
            }
        },
    };
</script>



// WEBPACK FOOTER //
// src/components/fxView/deposit/deposit.vue